export const drumPatterns = {
  "sections":[
    "Basic Patterns",
    "Electro",
    "House",
    "Miami Bass",
    "Hip Hop",
    "Funk and Soul",
    "Afro-Cuban",
    "Drum and Bass",
    "EDM",
    "Dub",
    "Breaks",
    "Hybrid Breaks With Alternate Endings",
    "Irregular Breaks",
    "Rolling Breaks",
    "Breaks - Snare",
    "Ghost Snares",
    "Breaks - Kick",
    "Drum Rolls"
  ],
  "labels":[
    "ONE AND SEVEN & FIVE AND THIRTEEN",
    "BOOTS N\u2019 CATS",
    "TINY HOUSE",
    "GOOD TO GO",
    "HIP HOP",
    "STANDARD BREAK 1",
    "STANDARD BREAK 2",
    "ROLLING BREAK",
    "THE UNKNOWN DRUMMER",
    "ROCK 1",
    "ROCK 2",
    "ROCK 3",
    "ROCK 4",
    "ELECTRO 1 - A",
    "ELECTRO 1 - B",
    "ELECTRO 2 - A",
    "ELECTRO 2 - B",
    "ELECTRO 3 - A",
    "ELECTRO 3 - B",
    "ELECTRO 4",
    "SIBERIAN NIGHTS",
    "NEW WAVE",
    "HOUSE 1",
    "HOUSE 2",
    "BRIT HOUSE",
    "FRENCH HOUSE",
    "DIRTY HOUSE",
    "DEEP HOUSE",
    "DEEPER HOUSE",
    "SLOW DEEP HOUSE",
    "FOOTWORK - A",
    "FOOTWORK - B",
    "MIAMI BASS - A",
    "MIAMI BASS - B",
    "SALLY",
    "ROCK THE PLANET",
    "HIP HOP 1 - A",
    "HIP HOP 1 - B",
    "HIP HOP 2 - A",
    "HIP HOP 2 - B",
    "HIP HOP 3 - A",
    "HIP HOP 3 - B",
    "HIP HOP 4 - A",
    "HIP HOP 4 - B",
    "HIP HOP 5",
    "HIP HOP 6",
    "HIP HOP 7",
    "HIP HOP 8",
    "TRAP - A",
    "TRAP - B",
    "AMEN BREAK - A",
    "AMEN BREAK - B",
    "AMEN BREAK - C",
    "AMEN BREAK - D",
    "THE FUNKY DRUMMER",
    "IMPEACH THE PRESIDENT",
    "WHEN THE LEVEE BREAKS",
    "IT\u2019S A NEW DAY",
    "THE BIG BEAT",
    "ASHLEY\u2019S ROACHCLIP",
    "PAPA WAS TOO",
    "SUPERSTITION",
    "CISSY STRUT (B-SECTION) - A",
    "CISSY STRUT (B-SECTION) - B",
    "CISSY STRUT (B-SECTION) - C",
    "CISSY STRUT (B-SECTION) - D",
    "HOOK AND SLING - A",
    "HOOK AND SLING - B",
    "HOOK AND SLING - C",
    "HOOK AND SLING - D",
    "KISSING MY LOVE - A",
    "KISSING MY LOVE - B",
    "KISSING MY LOVE - C",
    "KISSING MY LOVE - D",
    "KISSING MY LOVE - E",
    "LADY - A",
    "LADY - B",
    "KNOCKS ME OFF MY FEET - A",
    "KNOCKS ME OFF MY FEET - B",
    "THE THRILL IS GONE",
    "POP TECH - A",
    "POP TECH - B",
    "YA MAMA - A",
    "YA MAMA - B",
    "COLD SWEAT - A",
    "COLD SWEAT - B",
    "I GOT YOU (I FEEL GOOD) - A",
    "I GOT YOU (I FEEL GOOD) - B",
    "THE SAME BLOOD",
    "GROOVE ME",
    "LOOK-KA PY PY - A",
    "LOOK-KA PY PY - B",
    "USE ME - A",
    "USE ME - B",
    "USE ME - C",
    "USE ME - D",
    "FUNKY PRESIDENT",
    "GET UP - A",
    "GET UP - B",
    "EXPENSIVE SHIT",
    "CHUG CHUG CHUG-A-LUG",
    "THE FEZ - A",
    "THE FEZ - B",
    "ROCK STEADY",
    "SYNTHETIC SUBSTITUTION - A",
    "SYNTHETIC SUBSTITUTION - B",
    "COW\u2019D BELL - A",
    "COW\u2019D BELL - B",
    "PALM GREASE - A",
    "PALM GREASE - B",
    "O-O-H CHILD - A",
    "O-O-H CHILD - B",
    "LADY MARMALADE - A",
    "LADY MARMALADE - B",
    "HOT SWEAT - A",
    "HOT SWEAT - B",
    "HAITIAN DIVORCE",
    "COME DANCING - A",
    "COME DANCING - B",
    "RESPECT YOURSELF - A",
    "RESPECT YOURSELF - B",
    "EXPRESS YOURSELF - A",
    "EXPRESS YOURSELF - B",
    "LET A WOMAN BE A WOMAN",
    "LET A MAN BE A MAN",
    "BOOKS OF MOSES - A",
    "BOOKS OF MOSES - B",
    "MOTHER POPCORN - A",
    "MOTHER POPCORN - B",
    "STRT BTS - A",
    "STRT BTS - B",
    "I GOT THE FEELIN\u2019 - A",
    "I GOT THE FEELIN\u2019 - B",
    "MORE BOUNCE TO THE OUNCE",
    "SON CLAVE",
    "RUMBA",
    "BOSSA NOVA",
    "BOUTON",
    "GAHU",
    "SHIKO",
    "SOUKOUS",
    "DRUM AND BASS 1 - A",
    "DRUM AND BASS 1 - B",
    "DRUM AND BASS 2 - A",
    "DRUM AND BASS 2 - B",
    "DRUM AND BASS 3",
    "DRUM AND BASS 4 - A",
    "DRUM AND BASS 4 - B",
    "JUNGLE - A",
    "JUNGLE - B",
    "TECHNO",
    "DUBSTEP - A",
    "DUBSTEP - B",
    "DUBSTEP - RATCHETED",
    "UK GARAGE - A",
    "UK GARAGE - B",
    "SYNTH WAVE",
    "HALF DROP",
    "ONE DROP",
    "TWO DROP",
    "STEPPERS",
    "REGGAETON",
    "STANDARD BREAKBEAT 1",
    "STANDARD BREAKBEAT 2",
    "STANDARD BREAKBEAT 3",
    "POLYRHYTHMIC - A",
    "POLYRHYTHMIC - B",
    "HYBRID KICK 1 - A",
    "HYBRID KICK 1 - B1",
    "HYBRID KICK 1 - B2",
    "HYBRID KICK 1 - B3",
    "HYBRID KICK 1 - B4",
    "HYBRID KICK 1 - B5",
    "HYBRID KICK 1 - B6",
    "HYBRID KICK 2 - A",
    "HYBRID KICK 2 - B",
    "HYBRID KICK 3 - A",
    "HYBRID KICK 3 - B",
    "IRREGULAR 1 - A",
    "IRREGULAR 1 - B",
    "IRREGULAR 2 - A",
    "IRREGULAR 2 - B",
    "IRREGULAR 3",
    "ROLLING 1",
    "ROLLING 2",
    "ROLLING 3 - A",
    "ROLLING 3 - B",
    "ROLLING 4 - A",
    "ROLLING 4 - B",
    "ROLLING 5 - A",
    "ROLLING 5 - B",
    "ROLLING 6 - A",
    "ROLLING 6 - B",
    "ROLLING 7 - A",
    "ROLLING 7 - B",
    "ROLLING 7 - C",
    "ROLLING 7 - D",
    "ROLLING 8",
    "ROLLING 9 - A",
    "ROLLING 9 - B",
    "ROLLING 10",
    "ROLLING 11",
    "CONTEMPORARY SNARE 1 - A",
    "CONTEMPORARY SNARE 1 - B",
    "CONTEMPORARY SNARE 2 - A",
    "CONTEMPORARY SNARE 2 - B",
    "CONTEMPORARY SNARE 3 - A",
    "CONTEMPORARY SNARE 3 - B",
    "UNCONVENTIONAL SNARE 1 - A",
    "UNCONVENTIONAL SNARE 1 - B",
    "UNCONVENTIONAL SNARE 2 - A",
    "UNCONVENTIONAL SNARE 2 - B",
    "UNCONVENTIONAL SNARE 3 - A",
    "UNCONVENTIONAL SNARE 3 - B",
    "UNCONVENTIONAL SNARE 4 - A",
    "UNCONVENTIONAL SNARE 4 - B",
    "GHOST SNARE 1 - A",
    "GHOST SNARE 1 - B",
    "GHOST SNARE 2 - A",
    "GHOST SNARE 2 - B",
    "CONTEMPORARY KICK 1 - A",
    "CONTEMPORARY KICK 1 - B",
    "CONTEMPORARY KICK 2 - A",
    "CONTEMPORARY KICK 2 - B",
    "CONTEMPORARY KICK 3 - A",
    "CONTEMPORARY KICK 3 - B",
    "CONTEMPORARY KICK 4",
    "DRUM ROLL 1",
    "DRUM ROLL 2",
    "DRUM ROLL 3",
    "DRUM ROLL 4",
    "DRUM ROLL 5",
    "DRUM ROLL 6",
    "DRUM ROLL 7",
    "DRUM ROLL 8",
    "DRUM ROLL 9",
    "DRUM ROLL 10",
    "DRUM ROLL 11",
    "DRUM ROLL 12",
    "DRUM ROLL 13",
    "DRUM ROLL 14",
    "DRUM ROLL 15",
    "DRUM ROLL 16",
    "DRUM ROLL 17",
    "DRUM ROLL 18",
    "DRUM ROLL 19",
    "DRUM ROLL 20"
  ],
  "raw_patterns":[
    {
      "label":"ONE AND SEVEN & FIVE AND THIRTEEN",
      "section":"Basic Patterns",
      "sequences":{
        "BD":{
          "seq":"x.....x.........",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"BOOTS N\u2019 CATS",
      "section":"Basic Patterns",
      "sequences":{
        "BD":{
          "seq":"x.......x.......",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"TINY HOUSE",
      "section":"Basic Patterns",
      "sequences":{
        "OH":{
          "seq":"..x...x...x...x.",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "OH",
        "BD"
      ]
    },
    {
      "label":"GOOD TO GO",
      "section":"Basic Patterns",
      "sequences":{
        "BD":{
          "seq":"x..x..x...x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HIP HOP",
      "section":"Basic Patterns",
      "sequences":{
        "BD":{
          "seq":"x.x...xx......x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"STANDARD BREAK 1",
      "section":"Basic Patterns",
      "sequences":{
        "BD":{
          "seq":"x.........x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.xxx.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"STANDARD BREAK 2",
      "section":"Basic Patterns",
      "sequences":{
        "BD":{
          "seq":"x.........x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.xxx.x...x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"ROLLING BREAK",
      "section":"Basic Patterns",
      "sequences":{
        "BD":{
          "seq":"x......x..x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"THE UNKNOWN DRUMMER",
      "section":"Basic Patterns",
      "sequences":{
        "BD":{
          "seq":"x..x..x...x.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":".x..X..x....X...",
          "ratchet":false,
          "accented":true
        },
        "CH":{
          "seq":".xx.Xx.x.....x..",
          "ratchet":false,
          "accented":true
        },
        "OH":{
          "seq":"........x.....x.",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ]
    },
    {
      "label":"ROCK 1",
      "section":"Basic Patterns",
      "sequences":{
        "BD":{
          "seq":"x......xx.x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"x...............",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CY",
        "CH"
      ]
    },
    {
      "label":"ROCK 2",
      "section":"Basic Patterns",
      "sequences":{
        "BD":{
          "seq":"x......xx.x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"ROCK 3",
      "section":"Basic Patterns",
      "sequences":{
        "BD":{
          "seq":"x......xx.x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"..............x.",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "OH",
        "CH"
      ]
    },
    {
      "label":"ROCK 4",
      "section":"Basic Patterns",
      "sequences":{
        "BD":{
          "seq":"x......xx.x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x.xx",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"..............x.",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "OH",
        "CH"
      ]
    },
    {
      "label":"ELECTRO 1 - A",
      "section":"Electro",
      "sequences":{
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.....x.........",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "SN",
        "BD"
      ]
    },
    {
      "label":"ELECTRO 1 - B",
      "section":"Electro",
      "sequences":{
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.....x...x..x..",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "SN",
        "BD"
      ]
    },
    {
      "label":"ELECTRO 2 - A",
      "section":"Electro",
      "sequences":{
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.....x.........",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "SN",
        "BD"
      ]
    },
    {
      "label":"ELECTRO 2 - B",
      "section":"Electro",
      "sequences":{
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.........x..x..",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "SN",
        "BD"
      ]
    },
    {
      "label":"ELECTRO 3 - A",
      "section":"Electro",
      "sequences":{
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.....x....x....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "SN",
        "BD"
      ]
    },
    {
      "label":"ELECTRO 3 - B",
      "section":"Electro",
      "sequences":{
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.....x....x.x..",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "SN",
        "BD"
      ]
    },
    {
      "label":"ELECTRO 4",
      "section":"Electro",
      "sequences":{
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.....x...x..x..",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "SN",
        "BD"
      ]
    },
    {
      "label":"SIBERIAN NIGHTS",
      "section":"Electro",
      "sequences":{
        "CH":{
          "seq":"x.xxx.xxx.xxx.xx",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.....x.........",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CH",
        "SN",
        "BD"
      ]
    },
    {
      "label":"NEW WAVE",
      "section":"Electro",
      "sequences":{
        "BD":{
          "seq":"x.....x.xx......",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"xxxxxxxxxxxxxxxx",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"..x.............",
          "ratchet":false,
          "accented":false
        },
        "SH":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH",
        "SH"
      ]
    },
    {
      "label":"HOUSE 1",
      "section":"House",
      "sequences":{
        "BD":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"x...............",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"..x...x...x...x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CY",
        "OH"
      ]
    },
    {
      "label":"HOUSE 2",
      "section":"House",
      "sequences":{
        "BD":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"xxxxxxxxxxxxxxxx",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"..x..x....x..x..",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ]
    },
    {
      "label":"BRIT HOUSE",
      "section":"House",
      "sequences":{
        "BD":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        },
        "CL":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"..x...x...x...x.",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"xx.xxx.xxx.xxx.x",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"..x...x...x...x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "CL",
        "CY",
        "CH",
        "OH"
      ]
    },
    {
      "label":"FRENCH HOUSE",
      "section":"House",
      "sequences":{
        "BD":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        },
        "CL":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "SH":{
          "seq":"xxx.x.xxxxx.x.xx",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"xxxxxxxxxxxxxxxx",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":".x.x.x.x.x.x.x.x",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "CL",
        "SH",
        "CH",
        "OH"
      ]
    },
    {
      "label":"DIRTY HOUSE",
      "section":"House",
      "sequences":{
        "BD":{
          "seq":"x.X.x...x.x.x..X",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":true
        },
        "CL":{
          "seq":"..X.x...x.x.x...",
          "ratchet":false,
          "accented":true
        },
        "CH":{
          "seq":"..........x....X",
          "ratchet":false,
          "accented":true
        },
        "OH":{
          "seq":"..X.......x...x.",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CL",
        "CH",
        "OH"
      ]
    },
    {
      "label":"DEEP HOUSE",
      "section":"House",
      "sequences":{
        "BD":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        },
        "CL":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":".x.....x.x......",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"..x...x...x...x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "CL",
        "CH",
        "OH"
      ]
    },
    {
      "label":"DEEPER HOUSE",
      "section":"House",
      "sequences":{
        "BD":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        },
        "CL":{
          "seq":".x.......x......",
          "ratchet":false,
          "accented":false
        },
        "MT":{
          "seq":"..x....x..x.....",
          "ratchet":false,
          "accented":false
        },
        "SH":{
          "seq":"...x....x.......",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"..x...x...xx..x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "CL",
        "MT",
        "SH",
        "OH"
      ]
    },
    {
      "label":"SLOW DEEP HOUSE",
      "section":"House",
      "sequences":{
        "BD":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        },
        "CL":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "SH":{
          "seq":"xxxxxxxxxxxxxxxx",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"..xx..xx.xx...x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "CL",
        "SH",
        "CH",
        "OH"
      ]
    },
    {
      "label":"FOOTWORK - A",
      "section":"House",
      "sequences":{
        "BD":{
          "seq":"x..x..x.x..x..x.",
          "ratchet":false,
          "accented":false
        },
        "CL":{
          "seq":"............x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"..x.......x.....",
          "ratchet":false,
          "accented":false
        },
        "RS":{
          "seq":"xxxxxxxxxxxxxxxx",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "CL",
        "CH",
        "RS"
      ]
    },
    {
      "label":"FOOTWORK - B",
      "section":"House",
      "sequences":{
        "BD":{
          "seq":"x..x..x.x..x..x.",
          "ratchet":false,
          "accented":false
        },
        "CL":{
          "seq":"............x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"..x...xx..x...x.",
          "ratchet":false,
          "accented":false
        },
        "RS":{
          "seq":"xxxxxxxxxxxxxxxx",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "CL",
        "CH",
        "RS"
      ]
    },
    {
      "label":"MIAMI BASS - A",
      "section":"Miami Bass",
      "sequences":{
        "BD":{
          "seq":"x.....x.........",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.xxx.xxx.xxx.xx",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"MIAMI BASS - B",
      "section":"Miami Bass",
      "sequences":{
        "BD":{
          "seq":"x.....x...x..x..",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.xxx.xxx.xxx.xx",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"SALLY",
      "section":"Miami Bass",
      "sequences":{
        "BD":{
          "seq":"x.....x...x...x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "LT":{
          "seq":"x.....x...x...x.",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "LT",
        "CH"
      ]
    },
    {
      "label":"ROCK THE PLANET",
      "section":"Miami Bass",
      "sequences":{
        "BD":{
          "seq":"x..x..x.........",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.xxx.xxx.xxxxxx",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"HIP HOP 1 - A",
      "section":"Hip Hop",
      "sequences":{
        "BD":{
          "seq":"x.....xx...x..x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HIP HOP 1 - B",
      "section":"Hip Hop",
      "sequences":{
        "BD":{
          "seq":"x......x...x....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HIP HOP 2 - A",
      "section":"Hip Hop",
      "sequences":{
        "BD":{
          "seq":"x......xxx...x.x",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HIP HOP 2 - B",
      "section":"Hip Hop",
      "sequences":{
        "BD":{
          "seq":"x......xx..x....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x....x..x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HIP HOP 3 - A",
      "section":"Hip Hop",
      "sequences":{
        "BD":{
          "seq":"x.x.....x.x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HIP HOP 3 - B",
      "section":"Hip Hop",
      "sequences":{
        "BD":{
          "seq":"x.x.....xx.x....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HIP HOP 4 - A",
      "section":"Hip Hop",
      "sequences":{
        "BD":{
          "seq":"x..x...x.xx....x",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HIP HOP 4 - B",
      "section":"Hip Hop",
      "sequences":{
        "BD":{
          "seq":"x.x....xxxx.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HIP HOP 5",
      "section":"Hip Hop",
      "sequences":{
        "BD":{
          "seq":"x.x....xx.x....x",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HIP HOP 6",
      "section":"Hip Hop",
      "sequences":{
        "BD":{
          "seq":"x.x.......xx...x",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"HIP HOP 7",
      "section":"Hip Hop",
      "sequences":{
        "BD":{
          "seq":"x......x..x..x.x",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"HIP HOP 8",
      "section":"Hip Hop",
      "sequences":{
        "BD":{
          "seq":"x..x....x.xx....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"xx.xx.xxxx.xx.xx",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":".....x.......x..",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ]
    },
    {
      "label":"TRAP - A",
      "section":"Hip Hop",
      "sequences":{
        "BD":{
          "seq":"x.....x.....x...",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"........x.......",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"TRAP - B",
      "section":"Hip Hop",
      "sequences":{
        "BD":{
          "seq":"..x.x...........",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"........x.......",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"..x.x.x.x.x.11x.",
          "ratchet":true,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"AMEN BREAK - A",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x.x.......xx....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x.x..x..x",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"AMEN BREAK - B",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x.x.......xx....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".......x.x..x..x",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "RS":{
          "seq":"....x...........",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "RS"
      ]
    },
    {
      "label":"AMEN BREAK - C",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x.x.......x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".......x.x..x..x",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "RS":{
          "seq":"..............x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "RS"
      ]
    },
    {
      "label":"AMEN BREAK - D",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x.x.......x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".x..x..x.x....x.",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x...x.x.",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"..........x.....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "CY"
      ]
    },
    {
      "label":"THE FUNKY DRUMMER",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x.x...x...x..x..",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x.x.xx..x",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"xxxxxxx.xxxxx.xx",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":".......x.....x..",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ]
    },
    {
      "label":"IMPEACH THE PRESIDENT",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x......xx.....x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.xxx...x.x.",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"..........x.....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ]
    },
    {
      "label":"WHEN THE LEVEE BREAKS",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"xx.....x..xx....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"IT\u2019S A NEW DAY",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x.x.......xx...x",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"THE BIG BEAT",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x..x..x.x.......",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CL":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CL"
      ]
    },
    {
      "label":"ASHLEY\u2019S ROACHCLIP",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x.x...x.xx......",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x...x.x.",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"..........x.....",
          "ratchet":false,
          "accented":false
        },
        "CB":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH",
        "CB"
      ]
    },
    {
      "label":"PAPA WAS TOO",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x......xx.x....x",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"....x...x.x.x.xx",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"....x...........",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "CY"
      ]
    },
    {
      "label":"SUPERSTITION",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.xxxxx.x.xx",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"CISSY STRUT (B-SECTION) - A",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x..x.x...x.xx.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x.xx.....",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"............x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CY"
      ]
    },
    {
      "label":"CISSY STRUT (B-SECTION) - B",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x..x...x.x.xx.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"..x..xx.xx......",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"................",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CY"
      ]
    },
    {
      "label":"CISSY STRUT (B-SECTION) - C",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x...x..x.x.xx.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"..x.xxx..x......",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"............x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CY"
      ]
    },
    {
      "label":"CISSY STRUT (B-SECTION) - D",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x...x..x.x.xx.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"x.x..x..xx......",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"............x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CY"
      ]
    },
    {
      "label":"HOOK AND SLING - A",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x.x......x...xx.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.xx..x.x...",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"x.xx.x..xx.x..x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CY"
      ]
    },
    {
      "label":"HOOK AND SLING - B",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"..............x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"x...xx.x..xx..xx",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"xx.x..x.xx..x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CY"
      ]
    },
    {
      "label":"HOOK AND SLING - C",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"xx..........xx.x",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"..x.x.xx..xx..x.",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"x.x.xx.x.x..xx..",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CY"
      ]
    },
    {
      "label":"HOOK AND SLING - D",
      "section":"Funk and Soul",
      "sequences":{
        "BD":{
          "seq":"x.x..x.....x.xx.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x..x....x",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"x.x.xx.x........",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CY"
      ]
    },
    {
      "label":"KISSING MY LOVE - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"xxxxxxxxxxxxxxx.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x.x..x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"xx.x.......x..x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"KISSING MY LOVE - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"xxxxxxxxxxxxxxxx",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x.x..x..x",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"xx.x.......x.x..",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"KISSING MY LOVE - C",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"xxxxxxxxxxxxxxxx",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x.x.....x",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"xx.x......x.xx..",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"KISSING MY LOVE - D",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"xxxxxxxxxxxxxxx.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x....x..x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x..x.......x..x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"KISSING MY LOVE - E",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"xxxxxxxxxxxxxxx.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x.x..x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x..........x.x..",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"LADY - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"..x...x.........",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....xx..........",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.......x..x..x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"LADY - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"..x...x.........",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....xx..x.......",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x..........x..x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"KNOCKS ME OFF MY FEET - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x...xx.xx...x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.x.x..xx.x.x..x",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"KNOCKS ME OFF MY FEET - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x...xx.xx...x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.x.x..xx.x.x..x",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"THE THRILL IS GONE",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":".......xx.x.....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"POP TECH - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.......x.......",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x...............",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"POP TECH - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.......x.......",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":".x...........xxx",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"YA MAMA - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.......x.......",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "BD"
      ]
    },
    {
      "label":"YA MAMA - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x......xx.......",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "BD"
      ]
    },
    {
      "label":"COLD SWEAT - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x......x.",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.......x.x.....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"COLD SWEAT - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".x..x..x.x..x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"..x.....x.x...x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"I GOT YOU (I FEEL GOOD) - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.........x.....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"I GOT YOU (I FEEL GOOD) - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"..x...x...x...x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"THE SAME BLOOD",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.xxx.xxx.xx",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"...x.xx.....xxx.",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"xx......xx......",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"GROOVE ME",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x..xx..xxx.x.x.x",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"LOOK-KA PY PY - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".x..x..xx.x...x.",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x..x.x....x..xx.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"LOOK-KA PY PY - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".x..xx.xx.x...x.",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x..x.x.xx.x..xx.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"USE ME - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.xxxxxxx.xxxx",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"..x.x.xx.xx.x.xx",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x...x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"USE ME - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"xxx.xxxxxxx.xxxx",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".xx.x.xx.xx.x.xx",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"....x..x..x.x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"USE ME - C",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"xxxxxxxxxxxxxxxx",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x.x..x..x",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.x..x.xx.xx.x.x",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"USE ME - D",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"xxxxxxxxxx.x.x.x",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x.......x",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.x..x..xx.x.x.x",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"FUNKY PRESIDENT",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x..x...x.xx.....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"GET UP - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.xxx.x.x.xx",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.xx.x..x..x",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.........x...x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"GET UP - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.xxx.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.xx.x..x..x",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.........x...x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"EXPENSIVE SHIT",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.xxx.xxx.xxx.xx",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"xx.x.x..xx..xx..",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"...x..x.......x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"CHUG CHUG CHUG-A-LUG",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.xxx.xxx.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".xx.x..x.xx.x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x..x.x.x.x.x..x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"THE FEZ - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"..x...x...x...x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".x.xxx.x.x.xxx.x",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.......x.......",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"THE FEZ - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"..x...x...x...x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".x.xxx.x.x.xxx.x",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.......x..x..x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"ROCK STEADY",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.xxx.x.x.xx",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".x..xx.x.x..xx.x",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"..x.x..x..x.x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"SYNTHETIC SUBSTITUTION - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x...x.......",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.x....x.xxx...x",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"SYNTHETIC SUBSTITUTION - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.X.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....x...x.......",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"x.X....x.xxx...x",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"COW\u2019D BELL - A",
      "section":"Funk and Soul",
      "sequences":{
        "CB":{
          "seq":"x.xxx.xxx.xxx.xx",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".x.xxx.x.x.xxx.x",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x..x..xx..xx.x.x",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CB",
        "SN",
        "BD"
      ]
    },
    {
      "label":"COW\u2019D BELL - B",
      "section":"Funk and Soul",
      "sequences":{
        "CB":{
          "seq":"x.xxx.xxx.xxx.xx",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".x.xxx.x.x.xxx.x",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.xx...xx.xx.x.x",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CB",
        "SN",
        "BD"
      ]
    },
    {
      "label":"PALM GREASE - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"xxxx.xx.x.xx.xx.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x.x..x..x",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.......x......x",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"PALM GREASE - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.......X.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":".x....x.......x.",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"..x.............",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"O-O-H CHILD - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"xxX.xxX.xxX.xxX.",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":".x.xxx.x.x.xxx.x",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"x.X.....x.Xx....",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"O-O-H CHILD - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"xxX.xxX.xxX.xxX.",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":".x.xxx.x.x..x.X.",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"x.X.....x.Xx....",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"LADY MARMALADE - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.x...x.x.....x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"LADY MARMALADE - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.X.x.x.",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....x...x.......",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"............x...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"HOT SWEAT - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..xxx..x.xx",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.........x.....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"HOT SWEAT - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.xxx.x.x.xxx.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".x.xxx.x.x.xxx..",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"..xx......xx..x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"HAITIAN DIVORCE",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"xxX.xxxxxxX.xxxx",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":".x..x.xx.x..x.xx",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"..X.x.....X.x...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"COME DANCING - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".xx.xxx..xx.xxx.",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x......xx......x",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"COME DANCING - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.X.x.x.",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":".x..xx...x..xxx.",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"x.x..x.xx......x",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"RESPECT YOURSELF - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.....x.x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"RESPECT YOURSELF - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x...x.x.x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"EXPRESS YOURSELF - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"xxxxxxxxxxxxxxxx",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x.x.x.x.x",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x..x....x..x..x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"EXPRESS YOURSELF - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"xxxxxxxxxxxxxxxX",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....x..x.x.xx...",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"x..x....x..x..x.",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"LET A WOMAN BE A WOMAN",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.X.",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....x..x.xx.xx..",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"..x.....x.xx.xX.",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"LET A MAN BE A MAN",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.X.",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....x..x.x.xx...",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"..x.......x...X.",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"BOOKS OF MOSES - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x...x...x..x....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"BOOKS OF MOSES - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x...x...x.......",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"MOTHER POPCORN - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x.x....x.",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.x.......x.....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"MOTHER POPCORN - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".x.xxx.x.x.xxx.x",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"..x...x...x...x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"STRT BTS - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":".xx.xx.xX....xx.",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":".x..x..x...xx...",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"x..x..x...x.....",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"STRT BTS - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":".xx.xx.xX....xx.",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":".x..x..x....x...",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"x..x..x...x.....",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"I GOT THE FEELIN\u2019 - A",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.X.x.x.x.X.x.x.",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"......x..x....x.",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"x.X.......X.....",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"I GOT THE FEELIN\u2019 - B",
      "section":"Funk and Soul",
      "sequences":{
        "CY":{
          "seq":"x.x.x.x.X.x.x.x.",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":".x..xx.x.xxx.xxx",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"..x.....X...x.x.",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "CY",
        "SN",
        "BD"
      ]
    },
    {
      "label":"MORE BOUNCE TO THE OUNCE",
      "section":"Funk and Soul",
      "sequences":{
        "CH":{
          "seq":"..x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"x...............",
          "ratchet":false,
          "accented":false
        },
        "CL":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"x.......xx......",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "CH",
        "OH",
        "CL",
        "SN",
        "BD"
      ]
    },
    {
      "label":"SON CLAVE",
      "section":"Afro-Cuban",
      "sequences":{
        "BD":{
          "seq":"x..xx..xx..xx..x",
          "ratchet":false,
          "accented":false
        },
        "RS":{
          "seq":"x..x..x...x.x...",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"xxxxxxxxxxxxxxxx",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "RS",
        "CY"
      ]
    },
    {
      "label":"RUMBA",
      "section":"Afro-Cuban",
      "sequences":{
        "BD":{
          "seq":"x..xx..xx..xx..x",
          "ratchet":false,
          "accented":false
        },
        "RS":{
          "seq":"x..x...x..x.x...",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"xxxxxxxxxxxxxxxx",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "RS",
        "CY"
      ]
    },
    {
      "label":"BOSSA NOVA",
      "section":"Afro-Cuban",
      "sequences":{
        "BD":{
          "seq":"x..xx..xx..xx..x",
          "ratchet":false,
          "accented":false
        },
        "RS":{
          "seq":"x..x..x...x..x..",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"xxxxxxxxxxxxxxxx",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "RS",
        "CY"
      ]
    },
    {
      "label":"BOUTON",
      "section":"Afro-Cuban",
      "sequences":{
        "BD":{
          "seq":"x.......x.x...x.",
          "ratchet":false,
          "accented":false
        },
        "RS":{
          "seq":"...x..x.....x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.xxx.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "RS",
        "CH"
      ]
    },
    {
      "label":"GAHU",
      "section":"Afro-Cuban",
      "sequences":{
        "BD":{
          "seq":"x...x...x...x.x.",
          "ratchet":false,
          "accented":false
        },
        "RS":{
          "seq":"..xx..xx..xx..xx",
          "ratchet":false,
          "accented":false
        },
        "CB":{
          "seq":"x..x..x...x...x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "RS",
        "CB"
      ]
    },
    {
      "label":"SHIKO",
      "section":"Afro-Cuban",
      "sequences":{
        "BD":{
          "seq":"x...x.x.x...x.x.",
          "ratchet":false,
          "accented":false
        },
        "RS":{
          "seq":"..xx..xx..xx..xx",
          "ratchet":false,
          "accented":false
        },
        "CB":{
          "seq":"x...x.x...x.x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "RS",
        "CB"
      ]
    },
    {
      "label":"SOUKOUS",
      "section":"Afro-Cuban",
      "sequences":{
        "BD":{
          "seq":"x...x...x...x.x.",
          "ratchet":false,
          "accented":false
        },
        "RS":{
          "seq":"x..x..x.x..x..x.",
          "ratchet":false,
          "accented":false
        },
        "CB":{
          "seq":"x..x..x..xx.....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "RS",
        "CB"
      ]
    },
    {
      "label":"DRUM AND BASS 1 - A",
      "section":"Drum and Bass",
      "sequences":{
        "BD":{
          "seq":"x..x...x.xx....x",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"DRUM AND BASS 1 - B",
      "section":"Drum and Bass",
      "sequences":{
        "BD":{
          "seq":"x.x....xxxx.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"DRUM AND BASS 2 - A",
      "section":"Drum and Bass",
      "sequences":{
        "BD":{
          "seq":"x......x.x.x...x",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"DRUM AND BASS 2 - B",
      "section":"Drum and Bass",
      "sequences":{
        "BD":{
          "seq":"x..........x....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.xx",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"DRUM AND BASS 3",
      "section":"Drum and Bass",
      "sequences":{
        "BD":{
          "seq":"x.........x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"xxxxxxxxxxxxxxxx",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"......xxxx......",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ]
    },
    {
      "label":"DRUM AND BASS 4 - A",
      "section":"Drum and Bass",
      "sequences":{
        "BD":{
          "seq":"x.....x.........",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.....x.x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"x...............",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ]
    },
    {
      "label":"DRUM AND BASS 4 - B",
      "section":"Drum and Bass",
      "sequences":{
        "BD":{
          "seq":"....x.....x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"JUNGLE - A",
      "section":"Drum and Bass",
      "sequences":{
        "BD":{
          "seq":"x.x.......x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x.x....x.",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"x...............",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ]
    },
    {
      "label":"JUNGLE - B",
      "section":"Drum and Bass",
      "sequences":{
        "BD":{
          "seq":".xx.......x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".x..x..x.x....x.",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"TECHNO",
      "section":"EDM",
      "sequences":{
        "BD":{
          "seq":"x...x...x...x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":".........x......",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"..x...x...x...x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ]
    },
    {
      "label":"DUBSTEP - A",
      "section":"EDM",
      "sequences":{
        "BD":{
          "seq":"x.........x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"........x.......",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":".xx...x....x..x.",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"....x........x..",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ]
    },
    {
      "label":"DUBSTEP - B",
      "section":"EDM",
      "sequences":{
        "BD":{
          "seq":"x..x..x...x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"........x.......",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":".xx...x....x..x.",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"....x........x..",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ]
    },
    {
      "label":"DUBSTEP - RATCHETED",
      "section":"EDM",
      "sequences":{
        "BD":{
          "seq":"x..x....x..x....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x..x",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"xx...xxxxx.xxx.x",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":"..1...x.........",
          "ratchet":true,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ]
    },
    {
      "label":"UK GARAGE - A",
      "section":"EDM",
      "sequences":{
        "BD":{
          "seq":"x.........x.....",
          "ratchet":false,
          "accented":false
        },
        "CL":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"..xx..x...x...xx",
          "ratchet":false,
          "accented":false
        },
        "RS":{
          "seq":".x.....x.....x..",
          "ratchet":false,
          "accented":false
        },
        "MT":{
          "seq":".....x.....x....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "CL",
        "CH",
        "RS",
        "MT"
      ]
    },
    {
      "label":"UK GARAGE - B",
      "section":"EDM",
      "sequences":{
        "BD":{
          "seq":"x.........x.....",
          "ratchet":false,
          "accented":false
        },
        "CL":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"..x...x...x...x.",
          "ratchet":false,
          "accented":false
        },
        "RS":{
          "seq":".......x.....x..",
          "ratchet":false,
          "accented":false
        },
        "MT":{
          "seq":".....x.....x....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "CL",
        "CH",
        "RS",
        "MT"
      ]
    },
    {
      "label":"SYNTH WAVE",
      "section":"EDM",
      "sequences":{
        "BD":{
          "seq":"x.......x.......",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"xxxxxxxxxxxxxxxx",
          "ratchet":false,
          "accented":false
        },
        "OH":{
          "seq":".............x..",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ]
    },
    {
      "label":"HALF DROP",
      "section":"Dub",
      "sequences":{
        "BD":{
          "seq":"x...............",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"........x.......",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"ONE DROP",
      "section":"Dub",
      "sequences":{
        "BD":{
          "seq":"........x.......",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"........x.......",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"TWO DROP",
      "section":"Dub",
      "sequences":{
        "BD":{
          "seq":"x.......x.......",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"........x.......",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"STEPPERS",
      "section":"Dub",
      "sequences":{
        "BD":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"........x.......",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"REGGAETON",
      "section":"Dub",
      "sequences":{
        "BD":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"...x..x....x..x.",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"x.x.x.x.x.x.x.x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CH"
      ]
    },
    {
      "label":"STANDARD BREAKBEAT 1",
      "section":"Breaks",
      "sequences":{
        "BD":{
          "seq":"x.........x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"STANDARD BREAKBEAT 2",
      "section":"Breaks",
      "sequences":{
        "BD":{
          "seq":"x.x.......x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"STANDARD BREAKBEAT 3",
      "section":"Breaks",
      "sequences":{
        "BD":{
          "seq":"x.x...x...x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x.x..x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"POLYRHYTHMIC - A",
      "section":"Breaks",
      "sequences":{
        "BD":{
          "seq":"x.....x.........",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"..x..x....x.Xx.x",
          "ratchet":true,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"POLYRHYTHMIC - B",
      "section":"Breaks",
      "sequences":{
        "BD":{
          "seq":"..x.....x.......",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....x.X...x.X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HYBRID KICK 1 - A",
      "section":"Hybrid Breaks With Alternate Endings",
      "sequences":{
        "BD":{
          "seq":"x.......x.......",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HYBRID KICK 1 - B1",
      "section":"Hybrid Breaks With Alternate Endings",
      "sequences":{
        "BD":{
          "seq":"x.........x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x....x..x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HYBRID KICK 1 - B2",
      "section":"Hybrid Breaks With Alternate Endings",
      "sequences":{
        "BD":{
          "seq":"x.....x.x..x....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HYBRID KICK 1 - B3",
      "section":"Hybrid Breaks With Alternate Endings",
      "sequences":{
        "BD":{
          "seq":"x......x..x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HYBRID KICK 1 - B4",
      "section":"Hybrid Breaks With Alternate Endings",
      "sequences":{
        "BD":{
          "seq":"x........x......",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HYBRID KICK 1 - B5",
      "section":"Hybrid Breaks With Alternate Endings",
      "sequences":{
        "BD":{
          "seq":"x.x.....x.x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HYBRID KICK 1 - B6",
      "section":"Hybrid Breaks With Alternate Endings",
      "sequences":{
        "BD":{
          "seq":"x....x.x.xx.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HYBRID KICK 2 - A",
      "section":"Hybrid Breaks With Alternate Endings",
      "sequences":{
        "BD":{
          "seq":"x.x.....x.x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HYBRID KICK 2 - B",
      "section":"Hybrid Breaks With Alternate Endings",
      "sequences":{
        "BD":{
          "seq":"xx......x.x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HYBRID KICK 3 - A",
      "section":"Hybrid Breaks With Alternate Endings",
      "sequences":{
        "BD":{
          "seq":"x.......x.x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"HYBRID KICK 3 - B",
      "section":"Hybrid Breaks With Alternate Endings",
      "sequences":{
        "BD":{
          "seq":"xx......x.x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"IRREGULAR 1 - A",
      "section":"Irregular Breaks",
      "sequences":{
        "BD":{
          "seq":"x.xx..x...x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x..x....x..x",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"IRREGULAR 1 - B",
      "section":"Irregular Breaks",
      "sequences":{
        "BD":{
          "seq":"x.x....x..x.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....x.......x..X",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"IRREGULAR 2 - A",
      "section":"Irregular Breaks",
      "sequences":{
        "BD":{
          "seq":"x......x..x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"...x........x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"IRREGULAR 2 - B",
      "section":"Irregular Breaks",
      "sequences":{
        "BD":{
          "seq":"x.x...x...x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x...x...x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"IRREGULAR 3",
      "section":"Irregular Breaks",
      "sequences":{
        "BD":{
          "seq":"x..x....x.....x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":".x..x.....x..x..",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 1",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x.........x.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 2",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x.........x..x..",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 3 - A",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x.....x.....x...",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.....x.....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 3 - B",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x.....x.....x...",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.....x...x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 4 - A",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"xx..............",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 4 - B",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x......x.xx.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 5 - A",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x.x.......x.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 5 - B",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x..x......x.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 6 - A",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x.....x....x....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 6 - B",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x.x....x..x..x..",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 7 - A",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x......xx..x....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 7 - B",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x..x...x..x.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 7 - C",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x......x..x.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 7 - D",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x..x...x..x.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 8",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x......x........",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 9 - A",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x.......x.x.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 9 - B",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"xx......x.x.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 10",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x......x...x....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"ROLLING 11",
      "section":"Rolling Breaks",
      "sequences":{
        "BD":{
          "seq":"x....xx..xx.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"CONTEMPORARY SNARE 1 - A",
      "section":"Breaks - Snare",
      "sequences":{
        "BD":{
          "seq":"X.........X.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X....x....X.",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"CONTEMPORARY SNARE 1 - B",
      "section":"Breaks - Snare",
      "sequences":{
        "BD":{
          "seq":"..X.......X.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"......X..x..X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"CONTEMPORARY SNARE 2 - A",
      "section":"Breaks - Snare",
      "sequences":{
        "BD":{
          "seq":"X.x.......X.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"CONTEMPORARY SNARE 2 - B",
      "section":"Breaks - Snare",
      "sequences":{
        "BD":{
          "seq":"..X.......Xx....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X....x..X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"CONTEMPORARY SNARE 3 - A",
      "section":"Breaks - Snare",
      "sequences":{
        "BD":{
          "seq":"X.....X.......x.",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.....X..x.x",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"CONTEMPORARY SNARE 3 - B",
      "section":"Breaks - Snare",
      "sequences":{
        "BD":{
          "seq":"X..x..X.......x.",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.....X.....",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"UNCONVENTIONAL SNARE 1 - A",
      "section":"Breaks - Snare",
      "sequences":{
        "BD":{
          "seq":"x...x.....x.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"........X.....X.",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"UNCONVENTIONAL SNARE 1 - B",
      "section":"Breaks - Snare",
      "sequences":{
        "BD":{
          "seq":"x.....X...X.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"UNCONVENTIONAL SNARE 2 - A",
      "section":"Breaks - Snare",
      "sequences":{
        "BD":{
          "seq":"x...........x...",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X...X..x....",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"UNCONVENTIONAL SNARE 2 - B",
      "section":"Breaks - Snare",
      "sequences":{
        "BD":{
          "seq":"x...x...X.x.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":".......x....X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"UNCONVENTIONAL SNARE 3 - A",
      "section":"Breaks - Snare",
      "sequences":{
        "BD":{
          "seq":"x.....x......x..",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.....X.....",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"UNCONVENTIONAL SNARE 3 - B",
      "section":"Breaks - Snare",
      "sequences":{
        "BD":{
          "seq":"x...x...X.x.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":".......x....X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"UNCONVENTIONAL SNARE 4 - A",
      "section":"Breaks - Snare",
      "sequences":{
        "BD":{
          "seq":"x.x...x.x.......",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.....X.....",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"UNCONVENTIONAL SNARE 4 - B",
      "section":"Breaks - Snare",
      "sequences":{
        "BD":{
          "seq":"..x.......x.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"x...X....x..X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"GHOST SNARE 1 - A",
      "section":"Ghost Snares",
      "sequences":{
        "SN":{
          "seq":"....X..x.x..X..x",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "SN"
      ]
    },
    {
      "label":"GHOST SNARE 1 - B",
      "section":"Ghost Snares",
      "sequences":{
        "SN":{
          "seq":"....X..x.x..X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "SN"
      ]
    },
    {
      "label":"GHOST SNARE 2 - A",
      "section":"Ghost Snares",
      "sequences":{
        "SN":{
          "seq":".x..X..x....X..x",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "SN"
      ]
    },
    {
      "label":"GHOST SNARE 2 - B",
      "section":"Ghost Snares",
      "sequences":{
        "SN":{
          "seq":".x..X....x..X..x",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "SN"
      ]
    },
    {
      "label":"CONTEMPORARY KICK 1 - A",
      "section":"Breaks - Kick",
      "sequences":{
        "BD":{
          "seq":"x.........x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.........x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"CONTEMPORARY KICK 1 - B",
      "section":"Breaks - Kick",
      "sequences":{
        "BD":{
          "seq":"..x....x..x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"CONTEMPORARY KICK 2 - A",
      "section":"Breaks - Kick",
      "sequences":{
        "BD":{
          "seq":"..x....x..x.....",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X....x..X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"CONTEMPORARY KICK 2 - B",
      "section":"Breaks - Kick",
      "sequences":{
        "BD":{
          "seq":"..x.......x..x..",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"....X.......X...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"CONTEMPORARY KICK 3 - A",
      "section":"Breaks - Kick",
      "sequences":{
        "BD":{
          "seq":"x.........x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.........x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"CONTEMPORARY KICK 3 - B",
      "section":"Breaks - Kick",
      "sequences":{
        "BD":{
          "seq":"x.......x.x.....",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.......x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"CONTEMPORARY KICK 4",
      "section":"Breaks - Kick",
      "sequences":{
        "BD":{
          "seq":"x.......x.......",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"....x.....x.....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"DRUM ROLL 1",
      "section":"Drum Rolls",
      "sequences":{
        "HT":{
          "seq":"........xxX.....",
          "ratchet":false,
          "accented":true
        },
        "MT":{
          "seq":"...........xxX..",
          "ratchet":false,
          "accented":true
        },
        "LT":{
          "seq":"..............Xx",
          "ratchet":false,
          "accented":true
        },
        "OH":{
          "seq":"x...............",
          "ratchet":false,
          "accented":true
        },
        "CY":{
          "seq":"x...............",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "HT",
        "MT",
        "LT",
        "OH",
        "CY"
      ]
    },
    {
      "label":"DRUM ROLL 2",
      "section":"Drum Rolls",
      "sequences":{
        "BD":{
          "seq":"............x.x.",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"x.xxx.x.xxxx....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN"
      ]
    },
    {
      "label":"DRUM ROLL 3",
      "section":"Drum Rolls",
      "sequences":{
        "SN":{
          "seq":"xxx.xxx.x.x.xxxx",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "SN"
      ]
    },
    {
      "label":"DRUM ROLL 4",
      "section":"Drum Rolls",
      "sequences":{
        "BD":{
          "seq":"x.....x.....x...",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"...xx..xx......x",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"x.....x.....x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "BD",
        "SN",
        "CY"
      ]
    },
    {
      "label":"DRUM ROLL 5",
      "section":"Drum Rolls",
      "sequences":{
        "HT":{
          "seq":"x...............",
          "ratchet":false,
          "accented":true
        },
        "MT":{
          "seq":"....X...x.x.....",
          "ratchet":false,
          "accented":true
        },
        "LT":{
          "seq":"............x.x.",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "HT",
        "MT",
        "LT"
      ]
    },
    {
      "label":"DRUM ROLL 6",
      "section":"Drum Rolls",
      "sequences":{
        "HT":{
          "seq":"x...............",
          "ratchet":false,
          "accented":true
        },
        "MT":{
          "seq":"....X...x.x.....",
          "ratchet":false,
          "accented":true
        },
        "LT":{
          "seq":"............x.x.",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "HT",
        "MT",
        "LT"
      ]
    },
    {
      "label":"DRUM ROLL 7",
      "section":"Drum Rolls",
      "sequences":{
        "HT":{
          "seq":"..x.............",
          "ratchet":false,
          "accented":true
        },
        "MT":{
          "seq":"...x..xx........",
          "ratchet":false,
          "accented":true
        },
        "LT":{
          "seq":"..........xx.X..",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN"
      ]
    },
    {
      "label":"DRUM ROLL 8",
      "section":"Drum Rolls",
      "sequences":{
        "HT":{
          "seq":"..x.............",
          "ratchet":false,
          "accented":true
        },
        "MT":{
          "seq":"....X...X.xx....",
          "ratchet":false,
          "accented":true
        },
        "LT":{
          "seq":"..............Xx",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"x.....x.....x...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN"
      ]
    },
    {
      "label":"DRUM ROLL 9",
      "section":"Drum Rolls",
      "sequences":{
        "HT":{
          "seq":"..x.............",
          "ratchet":false,
          "accented":true
        },
        "MT":{
          "seq":"....X.....x.....",
          "ratchet":false,
          "accented":true
        },
        "LT":{
          "seq":"............X.x.",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"xx....x.xx......",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN"
      ]
    },
    {
      "label":"DRUM ROLL 10",
      "section":"Drum Rolls",
      "sequences":{
        "HT":{
          "seq":"..xx............",
          "ratchet":false,
          "accented":true
        },
        "MT":{
          "seq":"......XX..xx....",
          "ratchet":false,
          "accented":true
        },
        "LT":{
          "seq":"..............Xx",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"xx..xx..xx..xx..",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN"
      ]
    },
    {
      "label":"DRUM ROLL 11",
      "section":"Drum Rolls",
      "sequences":{
        "HT":{
          "seq":".x...........x..",
          "ratchet":false,
          "accented":true
        },
        "MT":{
          "seq":"....X..x........",
          "ratchet":false,
          "accented":true
        },
        "LT":{
          "seq":"..........X...Xx",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"x..x..x..x..x...",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"..x..x..x..x....",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN",
        "BD"
      ]
    },
    {
      "label":"DRUM ROLL 12",
      "section":"Drum Rolls",
      "sequences":{
        "HT":{
          "seq":"..X......x......",
          "ratchet":false,
          "accented":true
        },
        "MT":{
          "seq":"..........x.x...",
          "ratchet":false,
          "accented":true
        },
        "LT":{
          "seq":"...........X.Xx.",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"xx......x...x...",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"....x.x.........",
          "ratchet":false,
          "accented":true
        },
        "CY":{
          "seq":"....x.x.........",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN",
        "BD",
        "CY"
      ]
    },
    {
      "label":"DRUM ROLL 13",
      "section":"Drum Rolls",
      "sequences":{
        "HT":{
          "seq":".x..............",
          "ratchet":false,
          "accented":true
        },
        "MT":{
          "seq":".....X...x......",
          "ratchet":false,
          "accented":true
        },
        "LT":{
          "seq":".............x..",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":true
        },
        "BD":{
          "seq":"..xx..xx..xx..xx",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN",
        "BD"
      ]
    },
    {
      "label":"DRUM ROLL 14",
      "section":"Drum Rolls",
      "sequences":{
        "HT":{
          "seq":".........xxxX...",
          "ratchet":false,
          "accented":true
        },
        "MT":{
          "seq":"...xxxXXX....Xx.",
          "ratchet":false,
          "accented":true
        },
        "LT":{
          "seq":"xxx............x",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "HT",
        "MT",
        "LT"
      ]
    },
    {
      "label":"DRUM ROLL 15",
      "section":"Drum Rolls",
      "sequences":{
        "HT":{
          "seq":".x.......x......",
          "ratchet":false,
          "accented":true
        },
        "MT":{
          "seq":"................",
          "ratchet":false,
          "accented":true
        },
        "LT":{
          "seq":"...x...x...x...x",
          "ratchet":false,
          "accented":true
        },
        "SN":{
          "seq":"x...x...x...x...",
          "ratchet":false,
          "accented":true
        }
      },
      "length":16,
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN"
      ]
    },
    {
      "label":"DRUM ROLL 16",
      "section":"Drum Rolls",
      "sequences":{
        "SN":{
          "seq":"xx....xx....xx..",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"..x.x.....x...x.",
          "ratchet":false,
          "accented":false
        },
        "CH":{
          "seq":"..x.....x.....x.",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"....x.....x.....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "SN",
        "BD",
        "CH",
        "CY"
      ]
    },
    {
      "label":"DRUM ROLL 17",
      "section":"Drum Rolls",
      "sequences":{
        "HT":{
          "seq":"..xx............",
          "ratchet":false,
          "accented":false
        },
        "MT":{
          "seq":"........xx......",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"xx..x.xx..x.xxxx",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"....x.....x.....",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "HT",
        "MT",
        "SN",
        "CY"
      ]
    },
    {
      "label":"DRUM ROLL 18",
      "section":"Drum Rolls",
      "sequences":{
        "SN":{
          "seq":"x.....x.........",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"..x.x...x.x...x.",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"x.....x.....x...",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "SN",
        "BD",
        "CY"
      ]
    },
    {
      "label":"DRUM ROLL 19",
      "section":"Drum Rolls",
      "sequences":{
        "SN":{
          "seq":"xx....xx....xx..",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":"..x.x...x.x...x.",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"..x.x...x.x...x.",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "SN",
        "BD",
        "CY"
      ]
    },
    {
      "label":"DRUM ROLL 20",
      "section":"Drum Rolls",
      "sequences":{
        "HT":{
          "seq":"..x.x...........",
          "ratchet":false,
          "accented":false
        },
        "MT":{
          "seq":"......x.......x.",
          "ratchet":false,
          "accented":false
        },
        "LT":{
          "seq":"...............x",
          "ratchet":false,
          "accented":false
        },
        "SN":{
          "seq":"x.......x.x..x..",
          "ratchet":false,
          "accented":false
        },
        "BD":{
          "seq":".x.x.x.x.x.xx...",
          "ratchet":false,
          "accented":false
        },
        "CY":{
          "seq":"........x.......",
          "ratchet":false,
          "accented":false
        }
      },
      "length":16,
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN",
        "BD",
        "CY"
      ]
    }
  ],
  "patterns":{
    "oneandsevenfiveandthirteen":{
      "name":"oneandsevenfiveandthirteen",
      "label":"ONE AND SEVEN & FIVE AND THIRTEEN",
      "section":"Basic Patterns",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "bootsncats":{
      "name":"bootsncats",
      "label":"BOOTS N\u2019 CATS",
      "section":"Basic Patterns",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "tinyhouse":{
      "name":"tinyhouse",
      "label":"TINY HOUSE",
      "section":"Basic Patterns",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":null
      },
      "HATS":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "OH",
        "BD"
      ],
      "length":16,
      "OH":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "openHat":[
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "goodtogo":{
      "name":"goodtogo",
      "label":"GOOD TO GO",
      "section":"Basic Patterns",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hiphop":{
      "name":"hiphop",
      "label":"HIP HOP",
      "section":"Basic Patterns",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "standardbreak1":{
      "name":"standardbreak1",
      "label":"STANDARD BREAK 1",
      "section":"Basic Patterns",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "standardbreak2":{
      "name":"standardbreak2",
      "label":"STANDARD BREAK 2",
      "section":"Basic Patterns",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        1,
        0
      ]
    },
    "rollingbreak":{
      "name":"rollingbreak",
      "label":"ROLLING BREAK",
      "section":"Basic Patterns",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "theunknowndrummer":{
      "name":"theunknowndrummer",
      "label":"THE UNKNOWN DRUMMER",
      "section":"Basic Patterns",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ],
        "hihat":[
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0,
        1,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ],
      "hihat":[
        0,
        1,
        1,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ]
    },
    "rock1":{
      "name":"rock1",
      "label":"ROCK 1",
      "section":"Basic Patterns",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CY",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CY":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "openHat":[
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "rock2":{
      "name":"rock2",
      "label":"ROCK 2",
      "section":"Basic Patterns",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "rock3":{
      "name":"rock3",
      "label":"ROCK 3",
      "section":"Basic Patterns",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ],
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "OH",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "rock4":{
      "name":"rock4",
      "label":"ROCK 4",
      "section":"Basic Patterns",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ],
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "OH",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "electro1A":{
      "name":"electro1A",
      "label":"ELECTRO 1 - A",
      "section":"Electro",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "SN",
        "BD"
      ],
      "length":16,
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "electro1B":{
      "name":"electro1B",
      "label":"ELECTRO 1 - B",
      "section":"Electro",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "SN",
        "BD"
      ],
      "length":16,
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ]
      },
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0
      ]
    },
    "electro2A":{
      "name":"electro2A",
      "label":"ELECTRO 2 - A",
      "section":"Electro",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "SN",
        "BD"
      ],
      "length":16,
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "electro2B":{
      "name":"electro2B",
      "label":"ELECTRO 2 - B",
      "section":"Electro",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "SN",
        "BD"
      ],
      "length":16,
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ]
      },
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0
      ]
    },
    "electro3A":{
      "name":"electro3A",
      "label":"ELECTRO 3 - A",
      "section":"Electro",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "SN",
        "BD"
      ],
      "length":16,
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0
      ]
    },
    "electro3B":{
      "name":"electro3B",
      "label":"ELECTRO 3 - B",
      "section":"Electro",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "SN",
        "BD"
      ],
      "length":16,
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0
        ]
      },
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0
      ]
    },
    "electro4":{
      "name":"electro4",
      "label":"ELECTRO 4",
      "section":"Electro",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "SN",
        "BD"
      ],
      "length":16,
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ]
      },
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0
      ]
    },
    "siberiannights":{
      "name":"siberiannights",
      "label":"SIBERIAN NIGHTS",
      "section":"Electro",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CH",
        "SN",
        "BD"
      ],
      "length":16,
      "CH":{
        "hihat":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "hihat":[
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "newwave":{
      "name":"newwave",
      "label":"NEW WAVE",
      "section":"Electro",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ],
        "hihat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH",
        "SH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SH":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "house1":{
      "name":"house1",
      "label":"HOUSE 1",
      "section":"House",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CY",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CY":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "openHat":[
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0
      ]
    },
    "house2":{
      "name":"house2",
      "label":"HOUSE 2",
      "section":"House",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "hihat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      "openHat":[
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0
      ]
    },
    "brithouse":{
      "name":"brithouse",
      "label":"BRIT HOUSE",
      "section":"House",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ],
        "hihat":[
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "CL",
        "CY",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CL":{
        "snare":[
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "CY":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.6,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.6,
        0,
        0,
        0
      ],
      "openHat":[
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0
      ],
      "hihat":[
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1
      ]
    },
    "frenchhouse":{
      "name":"frenchhouse",
      "label":"FRENCH HOUSE",
      "section":"House",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1
        ],
        "hihat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "CL",
        "SH",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CL":{
        "snare":[
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "SH":{
        "openHat":[
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          1
        ]
      },
      "CH":{
        "hihat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "OH":{
        "openHat":[
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.6,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.6,
        0,
        0,
        0
      ],
      "openHat":[
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1
      ],
      "hihat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ]
    },
    "dirtyhouse":{
      "name":"dirtyhouse",
      "label":"DIRTY HOUSE",
      "section":"House",
      "PULSE":{
        "kick":[
          0.5,
          0,
          1,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          1
        ],
        "snare":[
          0,
          0,
          1,
          0,
          0.6,
          0,
          0,
          0,
          0.6,
          0,
          0.6,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ],
        "hihat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CL",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          1,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CL":{
        "snare":[
          0,
          0,
          1,
          0,
          0.6,
          0,
          0,
          0,
          0.6,
          0,
          0.6,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        1,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        1
      ],
      "snare":[
        0,
        0,
        1,
        0,
        0.6,
        0,
        0,
        0,
        0.6,
        0,
        0.6,
        0,
        0.6,
        0,
        0,
        0
      ],
      "hihat":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ],
      "openHat":[
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0
      ]
    },
    "deephouse":{
      "name":"deephouse",
      "label":"DEEP HOUSE",
      "section":"House",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ],
        "hihat":[
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "CL",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CL":{
        "snare":[
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.6,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.6,
        0,
        0,
        0
      ],
      "hihat":[
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "openHat":[
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0
      ]
    },
    "deeperhouse":{
      "name":"deeperhouse",
      "label":"DEEPER HOUSE",
      "section":"House",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        "tom1":null
      },
      "instruments":[
        "BD",
        "CL",
        "MT",
        "SH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CL":{
        "snare":[
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SH":{
        "openHat":[
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0.6,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.6,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom2":[
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ],
      "openHat":[
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        0
      ]
    },
    "slowdeephouse":{
      "name":"slowdeephouse",
      "label":"SLOW DEEP HOUSE",
      "section":"House",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          0,
          0,
          1,
          0
        ],
        "hihat":[
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "CL",
        "SH",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CL":{
        "snare":[
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "SH":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.6,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.6,
        0,
        0,
        0
      ],
      "openHat":[
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        1,
        0
      ],
      "hihat":[
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "footworkA":{
      "name":"footworkA",
      "label":"FOOTWORK - A",
      "section":"House",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "CL",
        "CH",
        "RS"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "CL":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "RS":{
        "snare":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0
      ],
      "snare":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      "hihat":[
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "footworkB":{
      "name":"footworkB",
      "label":"FOOTWORK - B",
      "section":"House",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "CL",
        "CH",
        "RS"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "CL":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "RS":{
        "snare":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0
      ],
      "snare":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      "hihat":[
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0
      ]
    },
    "miamibassA":{
      "name":"miamibassA",
      "label":"MIAMI BASS - A",
      "section":"Miami Bass",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1
      ]
    },
    "miamibassB":{
      "name":"miamibassB",
      "label":"MIAMI BASS - B",
      "section":"Miami Bass",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1
      ]
    },
    "sally":{
      "name":"sally",
      "label":"SALLY",
      "section":"Miami Bass",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":[
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ],
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "LT",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "LT":{
        "tom3":[
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "tom3":[
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "rocktheplanet":{
      "name":"rocktheplanet",
      "label":"ROCK THE PLANET",
      "section":"Miami Bass",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1
      ]
    },
    "hiphop1A":{
      "name":"hiphop1A",
      "label":"HIP HOP 1 - A",
      "section":"Hip Hop",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hiphop1B":{
      "name":"hiphop1B",
      "label":"HIP HOP 1 - B",
      "section":"Hip Hop",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hiphop2A":{
      "name":"hiphop2A",
      "label":"HIP HOP 2 - A",
      "section":"Hip Hop",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hiphop2B":{
      "name":"hiphop2B",
      "label":"HIP HOP 2 - B",
      "section":"Hip Hop",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hiphop3A":{
      "name":"hiphop3A",
      "label":"HIP HOP 3 - A",
      "section":"Hip Hop",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hiphop3B":{
      "name":"hiphop3B",
      "label":"HIP HOP 3 - B",
      "section":"Hip Hop",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hiphop4A":{
      "name":"hiphop4A",
      "label":"HIP HOP 4 - A",
      "section":"Hip Hop",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0.5
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0.5
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hiphop4B":{
      "name":"hiphop4B",
      "label":"HIP HOP 4 - B",
      "section":"Hip Hop",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hiphop5":{
      "name":"hiphop5",
      "label":"HIP HOP 5",
      "section":"Hip Hop",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hiphop6":{
      "name":"hiphop6",
      "label":"HIP HOP 6",
      "section":"Hip Hop",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0.5
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "hiphop7":{
      "name":"hiphop7",
      "label":"HIP HOP 7",
      "section":"Hip Hop",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "hiphop8":{
      "name":"hiphop8",
      "label":"HIP HOP 8",
      "section":"Hip Hop",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ],
        "hihat":[
          1,
          1,
          0,
          1,
          1,
          0,
          1,
          1,
          1,
          1,
          0,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          1,
          0,
          1,
          1,
          0,
          1,
          1,
          1,
          1,
          0,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        1,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        0,
        1,
        1
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0
      ]
    },
    "trapA":{
      "name":"trapA",
      "label":"TRAP - A",
      "section":"Hip Hop",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "trapB":{
      "name":"trapB",
      "label":"TRAP - B",
      "section":"Hip Hop",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          0,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          0,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0
        ]
      },
      "kick":[
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "hihat":[
        0,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        0
      ]
    },
    "amenbreakA":{
      "name":"amenbreakA",
      "label":"AMEN BREAK - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "amenbreakB":{
      "name":"amenbreakB",
      "label":"AMEN BREAK - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "RS"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "RS":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "amenbreakC":{
      "name":"amenbreakC",
      "label":"AMEN BREAK - C",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "RS"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "RS":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "amenbreakD":{
      "name":"amenbreakD",
      "label":"AMEN BREAK - D",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "CY"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "CY":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        1,
        0
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "thefunkydrummer":{
      "name":"thefunkydrummer",
      "label":"THE FUNKY DRUMMER",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ],
        "hihat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "CH":{
        "hihat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5
      ],
      "hihat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0
      ]
    },
    "impeachthepresident":{
      "name":"impeachthepresident",
      "label":"IMPEACH THE PRESIDENT",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        1,
        0,
        1,
        0
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "whentheleveebreaks":{
      "name":"whentheleveebreaks",
      "label":"WHEN THE LEVEE BREAKS",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "itsanewday":{
      "name":"itsanewday",
      "label":"IT\u2019S A NEW DAY",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0.5
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "thebigbeat":{
      "name":"thebigbeat",
      "label":"THE BIG BEAT",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CL"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CL":{
        "snare":[
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.6,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.6,
        0,
        0,
        0
      ]
    },
    "ashleysroachclip":{
      "name":"ashleysroachclip",
      "label":"ASHLEY\u2019S ROACHCLIP",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH",
        "CB"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CB":{
        "tom1":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        1,
        0
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ],
      "tom1":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "papawastoo":{
      "name":"papawastoo",
      "label":"PAPA WAS TOO",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "CY"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1
        ]
      },
      "CY":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        1
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "superstition":{
      "name":"superstition",
      "label":"SUPERSTITION",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          1
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        1,
        1
      ]
    },
    "cissystrutbsectionA":{
      "name":"cissystrutbsectionA",
      "label":"CISSY STRUT (B-SECTION) - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CY"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CY":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "cissystrutbsectionB":{
      "name":"cissystrutbsectionB",
      "label":"CISSY STRUT (B-SECTION) - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CY"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CY":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0
      ],
      "snare":[
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "cissystrutbsectionC":{
      "name":"cissystrutbsectionC",
      "label":"CISSY STRUT (B-SECTION) - C",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CY"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CY":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0
      ],
      "snare":[
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "cissystrutbsectionD":{
      "name":"cissystrutbsectionD",
      "label":"CISSY STRUT (B-SECTION) - D",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0
        ],
        "snare":[
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CY"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CY":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0
      ],
      "snare":[
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "hookandslingA":{
      "name":"hookandslingA",
      "label":"HOOK AND SLING - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          1,
          0,
          1,
          0,
          0,
          1,
          1,
          0,
          1,
          0,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CY"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CY":{
        "openHat":[
          1,
          0,
          1,
          1,
          0,
          1,
          0,
          0,
          1,
          1,
          0,
          1,
          0,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0.5,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0
      ],
      "openHat":[
        1,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        0
      ]
    },
    "hookandslingB":{
      "name":"hookandslingB",
      "label":"HOOK AND SLING - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0.5,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          0,
          1,
          0,
          0,
          1,
          0,
          1,
          1,
          0,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CY"
      ],
      "length":16,
      "BD":{
        "kick":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5
        ]
      },
      "CY":{
        "openHat":[
          1,
          1,
          0,
          1,
          0,
          0,
          1,
          0,
          1,
          1,
          0,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0
      ],
      "snare":[
        0.5,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5
      ],
      "openHat":[
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "hookandslingC":{
      "name":"hookandslingC",
      "label":"HOOK AND SLING - C",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          1,
          0,
          1,
          0,
          1,
          0,
          0,
          1,
          1,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CY"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          1,
          0,
          1,
          0,
          1,
          0,
          0,
          1,
          1,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5
      ],
      "snare":[
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0
      ],
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        1,
        0,
        1,
        0,
        1,
        0,
        0,
        1,
        1,
        0,
        0
      ]
    },
    "hookandslingD":{
      "name":"hookandslingD",
      "label":"HOOK AND SLING - D",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CY"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5
        ]
      },
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5
      ],
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "kissingmyloveA":{
      "name":"kissingmyloveA",
      "label":"KISSING MY LOVE - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0
      ]
    },
    "kissingmyloveB":{
      "name":"kissingmyloveB",
      "label":"KISSING MY LOVE - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0
        ]
      },
      "openHat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5
      ],
      "kick":[
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0
      ]
    },
    "kissingmyloveC":{
      "name":"kissingmyloveC",
      "label":"KISSING MY LOVE - C",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0
        ]
      },
      "openHat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5
      ],
      "kick":[
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0
      ]
    },
    "kissingmyloveD":{
      "name":"kissingmyloveD",
      "label":"KISSING MY LOVE - D",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0
      ]
    },
    "kissingmyloveE":{
      "name":"kissingmyloveE",
      "label":"KISSING MY LOVE - E",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0
        ]
      },
      "openHat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0
      ]
    },
    "ladyA":{
      "name":"ladyA",
      "label":"LADY - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0
      ]
    },
    "ladyB":{
      "name":"ladyB",
      "label":"LADY - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0
      ]
    },
    "knocksmeoffmyfeetA":{
      "name":"knocksmeoffmyfeetA",
      "label":"KNOCKS ME OFF MY FEET - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          0,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5
      ]
    },
    "knocksmeoffmyfeetB":{
      "name":"knocksmeoffmyfeetB",
      "label":"KNOCKS ME OFF MY FEET - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          0,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5
      ]
    },
    "thethrillisgone":{
      "name":"thethrillisgone",
      "label":"THE THRILL IS GONE",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "poptechA":{
      "name":"poptechA",
      "label":"POP TECH - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "poptechB":{
      "name":"poptechB",
      "label":"POP TECH - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0.5
        ]
      },
      "openHat":[
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0.5
      ]
    },
    "yamamaA":{
      "name":"yamamaA",
      "label":"YA MAMA - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":null
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "yamamaB":{
      "name":"yamamaB",
      "label":"YA MAMA - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":null
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "coldsweatA":{
      "name":"coldsweatA",
      "label":"COLD SWEAT - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "coldsweatB":{
      "name":"coldsweatB",
      "label":"COLD SWEAT - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0
      ]
    },
    "igotyouifeelgoodA":{
      "name":"igotyouifeelgoodA",
      "label":"I GOT YOU (I FEEL GOOD) - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "igotyouifeelgoodB":{
      "name":"igotyouifeelgoodB",
      "label":"I GOT YOU (I FEEL GOOD) - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0
      ]
    },
    "thesameblood":{
      "name":"thesameblood",
      "label":"THE SAME BLOOD",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0.5,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1
      ],
      "snare":[
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0.5,
        0
      ],
      "kick":[
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "grooveme":{
      "name":"grooveme",
      "label":"GROOVE ME",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5
      ]
    },
    "lookkapypyA":{
      "name":"lookkapypyA",
      "label":"LOOK-KA PY PY - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0
      ]
    },
    "lookkapypyB":{
      "name":"lookkapypyB",
      "label":"LOOK-KA PY PY - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0
      ]
    },
    "usemeA":{
      "name":"usemeA",
      "label":"USE ME - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1
      ],
      "snare":[
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "usemeB":{
      "name":"usemeB",
      "label":"USE ME - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1
      ],
      "snare":[
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5
      ],
      "kick":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "usemeC":{
      "name":"usemeC",
      "label":"USE ME - C",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5
        ]
      },
      "openHat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5
      ],
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5
      ]
    },
    "usemeD":{
      "name":"usemeD",
      "label":"USE ME - D",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5
        ]
      },
      "openHat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        1,
        0,
        1
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5
      ],
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5
      ]
    },
    "funkypresident":{
      "name":"funkypresident",
      "label":"FUNKY PRESIDENT",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "getupA":{
      "name":"getupA",
      "label":"GET UP - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        1
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0
      ]
    },
    "getupB":{
      "name":"getupB",
      "label":"GET UP - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0
      ]
    },
    "expensiveshit":{
      "name":"expensiveshit",
      "label":"EXPENSIVE SHIT",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1
      ],
      "snare":[
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0
      ],
      "kick":[
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0
      ]
    },
    "chugchugchugalug":{
      "name":"chugchugchugalug",
      "label":"CHUG CHUG CHUG-A-LUG",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0
      ]
    },
    "thefezA":{
      "name":"thefezA",
      "label":"THE FEZ - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "thefezB":{
      "name":"thefezB",
      "label":"THE FEZ - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0
      ]
    },
    "rocksteady":{
      "name":"rocksteady",
      "label":"ROCK STEADY",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        1
      ],
      "snare":[
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5
      ],
      "kick":[
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "syntheticsubstitutionA":{
      "name":"syntheticsubstitutionA",
      "label":"SYNTHETIC SUBSTITUTION - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0,
        0,
        0.5
      ]
    },
    "syntheticsubstitutionB":{
      "name":"syntheticsubstitutionB",
      "label":"SYNTHETIC SUBSTITUTION - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          1,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          1,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        1,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0,
        0,
        0.5
      ]
    },
    "cowdbellA":{
      "name":"cowdbellA",
      "label":"COW\u2019D BELL - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5
        ],
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "instruments":[
        "CB",
        "SN",
        "BD"
      ],
      "length":16,
      "CB":{
        "tom1":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5
        ]
      },
      "tom1":[
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1
      ],
      "snare":[
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5
      ],
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5
      ]
    },
    "cowdbellB":{
      "name":"cowdbellB",
      "label":"COW\u2019D BELL - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5
        ],
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "instruments":[
        "CB",
        "SN",
        "BD"
      ],
      "length":16,
      "CB":{
        "tom1":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5
        ]
      },
      "tom1":[
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1
      ],
      "snare":[
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5
      ],
      "kick":[
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5
      ]
    },
    "palmgreaseA":{
      "name":"palmgreaseA",
      "label":"PALM GREASE - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          1,
          0,
          1,
          1,
          0,
          1,
          0,
          1,
          1,
          0,
          1,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          1,
          1,
          1,
          0,
          1,
          1,
          0,
          1,
          0,
          1,
          1,
          0,
          1,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5
        ]
      },
      "openHat":[
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        0,
        1,
        0,
        1,
        1,
        0,
        1,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5
      ]
    },
    "palmgreaseB":{
      "name":"palmgreaseB",
      "label":"PALM GREASE - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0
      ],
      "kick":[
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "oohchildA":{
      "name":"oohchildA",
      "label":"O-O-H CHILD - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          1,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          1,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5
      ],
      "kick":[
        0.5,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        1,
        0.5,
        0,
        0,
        0,
        0
      ]
    },
    "oohchildB":{
      "name":"oohchildB",
      "label":"O-O-H CHILD - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          1,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          1,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          1,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          1,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        1,
        0
      ],
      "kick":[
        0.5,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        1,
        0.5,
        0,
        0,
        0,
        0
      ]
    },
    "ladymarmaladeA":{
      "name":"ladymarmaladeA",
      "label":"LADY MARMALADE - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0
      ]
    },
    "ladymarmaladeB":{
      "name":"ladymarmaladeB",
      "label":"LADY MARMALADE - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "kick":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hotsweatA":{
      "name":"hotsweatA",
      "label":"HOT SWEAT - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "hotsweatB":{
      "name":"hotsweatB",
      "label":"HOT SWEAT - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0
      ],
      "kick":[
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0
      ]
    },
    "haitiandivorce":{
      "name":"haitiandivorce",
      "label":"HAITIAN DIVORCE",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0,
          1,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          1,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1
      ],
      "snare":[
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5
      ],
      "kick":[
        0,
        0,
        1,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "comedancingA":{
      "name":"comedancingA",
      "label":"COME DANCING - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5
        ],
        "snare":[
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0.5,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5
      ]
    },
    "comedancingB":{
      "name":"comedancingB",
      "label":"COME DANCING - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5
        ],
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0.5,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0.5,
        0
      ],
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5
      ]
    },
    "respectyourselfA":{
      "name":"respectyourselfA",
      "label":"RESPECT YOURSELF - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "respectyourselfB":{
      "name":"respectyourselfB",
      "label":"RESPECT YOURSELF - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "expressyourselfA":{
      "name":"expressyourselfA",
      "label":"EXPRESS YOURSELF - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5
      ],
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0
      ]
    },
    "expressyourselfB":{
      "name":"expressyourselfB",
      "label":"EXPRESS YOURSELF - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0
      ]
    },
    "letawomanbeawoman":{
      "name":"letawomanbeawoman",
      "label":"LET A WOMAN BE A WOMAN",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          1,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0.5,
          1,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0
      ],
      "kick":[
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0.5,
        1,
        0
      ]
    },
    "letamanbeaman":{
      "name":"letamanbeaman",
      "label":"LET A MAN BE A MAN",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          1,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        1,
        0
      ]
    },
    "booksofmosesA":{
      "name":"booksofmosesA",
      "label":"BOOKS OF MOSES - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0
      ]
    },
    "booksofmosesB":{
      "name":"booksofmosesB",
      "label":"BOOKS OF MOSES - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "motherpopcornA":{
      "name":"motherpopcornA",
      "label":"MOTHER POPCORN - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0
      ],
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "motherpopcornB":{
      "name":"motherpopcornB",
      "label":"MOTHER POPCORN - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5
      ],
      "kick":[
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0
      ]
    },
    "strtbtsA":{
      "name":"strtbtsA",
      "label":"STRT BTS - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          0,
          0,
          0,
          1,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          0,
          0,
          0,
          1,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        0,
        1,
        1,
        0,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "strtbtsB":{
      "name":"strtbtsB",
      "label":"STRT BTS - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          0,
          0,
          0,
          1,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          1,
          1,
          0,
          0,
          0,
          0,
          1,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        0,
        1,
        1,
        0,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "igotthefeelinA":{
      "name":"igotthefeelinA",
      "label":"I GOT THE FEELIN\u2019 - A",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0
      ],
      "kick":[
        0.5,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "igotthefeelinB":{
      "name":"igotthefeelinB",
      "label":"I GOT THE FEELIN\u2019 - B",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CY",
        "SN",
        "BD"
      ],
      "length":16,
      "CY":{
        "openHat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0.5
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0
        ]
      },
      "openHat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5,
        0.5,
        0.5
      ],
      "kick":[
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0
      ]
    },
    "morebouncetotheounce":{
      "name":"morebouncetotheounce",
      "label":"MORE BOUNCE TO THE OUNCE",
      "section":"Funk and Soul",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":[
          0,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "CH",
        "OH",
        "CL",
        "SN",
        "BD"
      ],
      "length":16,
      "CH":{
        "hihat":[
          0,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "OH":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CL":{
        "snare":[
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "hihat":[
        0,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "openHat":[
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "sonclave":{
      "name":"sonclave",
      "label":"SON CLAVE",
      "section":"Afro-Cuban",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5
        ],
        "snare":[
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "RS",
        "CY"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "RS":{
        "snare":[
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "CY":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5
      ],
      "snare":[
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0
      ],
      "openHat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ]
    },
    "rumba":{
      "name":"rumba",
      "label":"RUMBA",
      "section":"Afro-Cuban",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5
        ],
        "snare":[
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "RS",
        "CY"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "RS":{
        "snare":[
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "CY":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5
      ],
      "snare":[
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0
      ],
      "openHat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ]
    },
    "bossanova":{
      "name":"bossanova",
      "label":"BOSSA NOVA",
      "section":"Afro-Cuban",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5
        ],
        "snare":[
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "RS",
        "CY"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "RS":{
        "snare":[
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "CY":{
        "openHat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5
      ],
      "snare":[
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0
      ],
      "openHat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ]
    },
    "bouton":{
      "name":"bouton",
      "label":"BOUTON",
      "section":"Afro-Cuban",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "RS",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "RS":{
        "snare":[
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          1,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0
      ],
      "snare":[
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        1,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "gahu":{
      "name":"gahu",
      "label":"GAHU",
      "section":"Afro-Cuban",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":[
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "instruments":[
        "BD",
        "RS",
        "CB"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0
        ]
      },
      "RS":{
        "snare":[
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1
        ]
      },
      "CB":{
        "tom1":[
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0
      ],
      "snare":[
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1
      ],
      "tom1":[
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0
      ]
    },
    "shiko":{
      "name":"shiko",
      "label":"SHIKO",
      "section":"Afro-Cuban",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":[
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "instruments":[
        "BD",
        "RS",
        "CB"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0
        ]
      },
      "RS":{
        "snare":[
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1
        ]
      },
      "CB":{
        "tom1":[
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0
      ],
      "snare":[
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1
      ],
      "tom1":[
        1,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "soukous":{
      "name":"soukous",
      "label":"SOUKOUS",
      "section":"Afro-Cuban",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0
        ],
        "snare":[
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":[
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "instruments":[
        "BD",
        "RS",
        "CB"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0
        ]
      },
      "RS":{
        "snare":[
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0
        ]
      },
      "CB":{
        "tom1":[
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0
      ],
      "snare":[
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0
      ],
      "tom1":[
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "drumandbass1A":{
      "name":"drumandbass1A",
      "label":"DRUM AND BASS 1 - A",
      "section":"Drum and Bass",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0.5
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0.5
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "drumandbass1B":{
      "name":"drumandbass1B",
      "label":"DRUM AND BASS 1 - B",
      "section":"Drum and Bass",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "drumandbass2A":{
      "name":"drumandbass2A",
      "label":"DRUM AND BASS 2 - A",
      "section":"Drum and Bass",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "drumandbass2B":{
      "name":"drumandbass2B",
      "label":"DRUM AND BASS 2 - B",
      "section":"Drum and Bass",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          1
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        1
      ]
    },
    "drumandbass3":{
      "name":"drumandbass3",
      "label":"DRUM AND BASS 3",
      "section":"Drum and Bass",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "drumandbass4A":{
      "name":"drumandbass4A",
      "label":"DRUM AND BASS 4 - A",
      "section":"Drum and Bass",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "OH":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "openHat":[
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "drumandbass4B":{
      "name":"drumandbass4B",
      "label":"DRUM AND BASS 4 - B",
      "section":"Drum and Bass",
      "PULSE":{
        "kick":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "jungleA":{
      "name":"jungleA",
      "label":"JUNGLE - A",
      "section":"Drum and Bass",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "OH":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ],
      "openHat":[
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "jungleB":{
      "name":"jungleB",
      "label":"JUNGLE - B",
      "section":"Drum and Bass",
      "PULSE":{
        "kick":[
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "techno":{
      "name":"techno",
      "label":"TECHNO",
      "section":"EDM",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ],
        "hihat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "openHat":[
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0
      ]
    },
    "dubstepA":{
      "name":"dubstepA",
      "label":"DUBSTEP - A",
      "section":"EDM",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ],
        "hihat":[
          0,
          1,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          0,
          1,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "hihat":[
        0,
        1,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        0
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0
      ]
    },
    "dubstepB":{
      "name":"dubstepB",
      "label":"DUBSTEP - B",
      "section":"EDM",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ],
        "hihat":[
          0,
          1,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          0,
          1,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "hihat":[
        0,
        1,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        0
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0
      ]
    },
    "dubstepRATCHETED":{
      "name":"dubstepRATCHETED",
      "label":"DUBSTEP - RATCHETED",
      "section":"EDM",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":[
          1,
          1,
          0,
          0,
          0,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "CH":{
        "hihat":[
          1,
          1,
          0,
          0,
          0,
          1,
          1,
          1,
          1,
          1,
          0,
          1,
          1,
          1,
          0,
          1
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5
      ],
      "hihat":[
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        0,
        1
      ],
      "openHat":[
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "ukgarageA":{
      "name":"ukgarageA",
      "label":"UK GARAGE - A",
      "section":"EDM",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0
        ],
        "tom1":null
      },
      "instruments":[
        "BD",
        "CL",
        "CH",
        "RS",
        "MT"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CL":{
        "snare":[
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          1
        ]
      },
      "RS":{
        "snare":[
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0
      ],
      "hihat":[
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        1
      ],
      "tom2":[
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0
      ]
    },
    "ukgarageB":{
      "name":"ukgarageB",
      "label":"UK GARAGE - B",
      "section":"EDM",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0
        ],
        "tom1":null
      },
      "instruments":[
        "BD",
        "CL",
        "CH",
        "RS",
        "MT"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CL":{
        "snare":[
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.6,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "RS":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0
      ],
      "hihat":[
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0
      ],
      "tom2":[
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0
      ]
    },
    "synthwave":{
      "name":"synthwave",
      "label":"SYNTH WAVE",
      "section":"EDM",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ],
        "hihat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH",
        "OH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1
        ]
      },
      "OH":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0
      ]
    },
    "halfdrop":{
      "name":"halfdrop",
      "label":"HALF DROP",
      "section":"Dub",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "onedrop":{
      "name":"onedrop",
      "label":"ONE DROP",
      "section":"Dub",
      "PULSE":{
        "kick":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "twodrop":{
      "name":"twodrop",
      "label":"TWO DROP",
      "section":"Dub",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "steppers":{
      "name":"steppers",
      "label":"STEPPERS",
      "section":"Dub",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "reggaeton":{
      "name":"reggaeton",
      "label":"REGGAETON",
      "section":"Dub",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CH"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0
        ]
      },
      "CH":{
        "hihat":[
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0
      ],
      "hihat":[
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "standardbreakbeat1":{
      "name":"standardbreakbeat1",
      "label":"STANDARD BREAKBEAT 1",
      "section":"Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "standardbreakbeat2":{
      "name":"standardbreakbeat2",
      "label":"STANDARD BREAKBEAT 2",
      "section":"Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "standardbreakbeat3":{
      "name":"standardbreakbeat3",
      "label":"STANDARD BREAKBEAT 3",
      "section":"Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "polyrhythmicA":{
      "name":"polyrhythmicA",
      "label":"POLYRHYTHMIC - A",
      "section":"Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          1,
          0.5,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          1,
          0.5,
          0,
          0.5
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        1,
        0.5,
        0,
        0.5
      ]
    },
    "polyrhythmicB":{
      "name":"polyrhythmicB",
      "label":"POLYRHYTHMIC - B",
      "section":"Breaks",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          1,
          0,
          0,
          0,
          0.5,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          1,
          0,
          0,
          0,
          0.5,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        1,
        0,
        0,
        0,
        0.5,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "hybridkick1A":{
      "name":"hybridkick1A",
      "label":"HYBRID KICK 1 - A",
      "section":"Hybrid Breaks With Alternate Endings",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hybridkick1B1":{
      "name":"hybridkick1B1",
      "label":"HYBRID KICK 1 - B1",
      "section":"Hybrid Breaks With Alternate Endings",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hybridkick1B2":{
      "name":"hybridkick1B2",
      "label":"HYBRID KICK 1 - B2",
      "section":"Hybrid Breaks With Alternate Endings",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hybridkick1B3":{
      "name":"hybridkick1B3",
      "label":"HYBRID KICK 1 - B3",
      "section":"Hybrid Breaks With Alternate Endings",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hybridkick1B4":{
      "name":"hybridkick1B4",
      "label":"HYBRID KICK 1 - B4",
      "section":"Hybrid Breaks With Alternate Endings",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hybridkick1B5":{
      "name":"hybridkick1B5",
      "label":"HYBRID KICK 1 - B5",
      "section":"Hybrid Breaks With Alternate Endings",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hybridkick1B6":{
      "name":"hybridkick1B6",
      "label":"HYBRID KICK 1 - B6",
      "section":"Hybrid Breaks With Alternate Endings",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hybridkick2A":{
      "name":"hybridkick2A",
      "label":"HYBRID KICK 2 - A",
      "section":"Hybrid Breaks With Alternate Endings",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hybridkick2B":{
      "name":"hybridkick2B",
      "label":"HYBRID KICK 2 - B",
      "section":"Hybrid Breaks With Alternate Endings",
      "PULSE":{
        "kick":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hybridkick3A":{
      "name":"hybridkick3A",
      "label":"HYBRID KICK 3 - A",
      "section":"Hybrid Breaks With Alternate Endings",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "hybridkick3B":{
      "name":"hybridkick3B",
      "label":"HYBRID KICK 3 - B",
      "section":"Hybrid Breaks With Alternate Endings",
      "PULSE":{
        "kick":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "irregular1A":{
      "name":"irregular1A",
      "label":"IRREGULAR 1 - A",
      "section":"Irregular Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5
      ]
    },
    "irregular1B":{
      "name":"irregular1B",
      "label":"IRREGULAR 1 - B",
      "section":"Irregular Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          1
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          1
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        1
      ]
    },
    "irregular2A":{
      "name":"irregular2A",
      "label":"IRREGULAR 2 - A",
      "section":"Irregular Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "irregular2B":{
      "name":"irregular2B",
      "label":"IRREGULAR 2 - B",
      "section":"Irregular Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "irregular3":{
      "name":"irregular3",
      "label":"IRREGULAR 3",
      "section":"Irregular Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0
      ],
      "snare":[
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0
      ]
    },
    "rolling1":{
      "name":"rolling1",
      "label":"ROLLING 1",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "rolling2":{
      "name":"rolling2",
      "label":"ROLLING 2",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "rolling3A":{
      "name":"rolling3A",
      "label":"ROLLING 3 - A",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "rolling3B":{
      "name":"rolling3B",
      "label":"ROLLING 3 - B",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0
      ]
    },
    "rolling4A":{
      "name":"rolling4A",
      "label":"ROLLING 4 - A",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "rolling4B":{
      "name":"rolling4B",
      "label":"ROLLING 4 - B",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "rolling5A":{
      "name":"rolling5A",
      "label":"ROLLING 5 - A",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "rolling5B":{
      "name":"rolling5B",
      "label":"ROLLING 5 - B",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "rolling6A":{
      "name":"rolling6A",
      "label":"ROLLING 6 - A",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "rolling6B":{
      "name":"rolling6B",
      "label":"ROLLING 6 - B",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "rolling7A":{
      "name":"rolling7A",
      "label":"ROLLING 7 - A",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "rolling7B":{
      "name":"rolling7B",
      "label":"ROLLING 7 - B",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "rolling7C":{
      "name":"rolling7C",
      "label":"ROLLING 7 - C",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "rolling7D":{
      "name":"rolling7D",
      "label":"ROLLING 7 - D",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "rolling8":{
      "name":"rolling8",
      "label":"ROLLING 8",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "rolling9A":{
      "name":"rolling9A",
      "label":"ROLLING 9 - A",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "rolling9B":{
      "name":"rolling9B",
      "label":"ROLLING 9 - B",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "rolling10":{
      "name":"rolling10",
      "label":"ROLLING 10",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "rolling11":{
      "name":"rolling11",
      "label":"ROLLING 11",
      "section":"Rolling Breaks",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "contemporarysnare1A":{
      "name":"contemporarysnare1A",
      "label":"CONTEMPORARY SNARE 1 - A",
      "section":"Breaks - Snare",
      "PULSE":{
        "kick":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "kick":[
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        1,
        0
      ]
    },
    "contemporarysnare1B":{
      "name":"contemporarysnare1B",
      "label":"CONTEMPORARY SNARE 1 - B",
      "section":"Breaks - Snare",
      "PULSE":{
        "kick":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0.5,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "contemporarysnare2A":{
      "name":"contemporarysnare2A",
      "label":"CONTEMPORARY SNARE 2 - A",
      "section":"Breaks - Snare",
      "PULSE":{
        "kick":[
          1,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          1,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        1,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "contemporarysnare2B":{
      "name":"contemporarysnare2B",
      "label":"CONTEMPORARY SNARE 2 - B",
      "section":"Breaks - Snare",
      "PULSE":{
        "kick":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0.5,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "contemporarysnare3A":{
      "name":"contemporarysnare3A",
      "label":"CONTEMPORARY SNARE 3 - A",
      "section":"Breaks - Snare",
      "PULSE":{
        "kick":[
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0.5,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0.5,
          0,
          0.5
        ]
      },
      "kick":[
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0.5,
        0,
        0.5
      ]
    },
    "contemporarysnare3B":{
      "name":"contemporarysnare3B",
      "label":"CONTEMPORARY SNARE 3 - B",
      "section":"Breaks - Snare",
      "PULSE":{
        "kick":[
          1,
          0,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          1,
          0,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        1,
        0,
        0,
        0.5,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "unconventionalsnare1A":{
      "name":"unconventionalsnare1A",
      "label":"UNCONVENTIONAL SNARE 1 - A",
      "section":"Breaks - Snare",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ]
    },
    "unconventionalsnare1B":{
      "name":"unconventionalsnare1B",
      "label":"UNCONVENTIONAL SNARE 1 - B",
      "section":"Breaks - Snare",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "unconventionalsnare2A":{
      "name":"unconventionalsnare2A",
      "label":"UNCONVENTIONAL SNARE 2 - A",
      "section":"Breaks - Snare",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0
      ]
    },
    "unconventionalsnare2B":{
      "name":"unconventionalsnare2B",
      "label":"UNCONVENTIONAL SNARE 2 - B",
      "section":"Breaks - Snare",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          1,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          1,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        1,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "unconventionalsnare3A":{
      "name":"unconventionalsnare3A",
      "label":"UNCONVENTIONAL SNARE 3 - A",
      "section":"Breaks - Snare",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "unconventionalsnare3B":{
      "name":"unconventionalsnare3B",
      "label":"UNCONVENTIONAL SNARE 3 - B",
      "section":"Breaks - Snare",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          1,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          1,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        1,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "unconventionalsnare4A":{
      "name":"unconventionalsnare4A",
      "label":"UNCONVENTIONAL SNARE 4 - A",
      "section":"Breaks - Snare",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "unconventionalsnare4B":{
      "name":"unconventionalsnare4B",
      "label":"UNCONVENTIONAL SNARE 4 - B",
      "section":"Breaks - Snare",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0.5,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0.5,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "ghostsnare1A":{
      "name":"ghostsnare1A",
      "label":"GHOST SNARE 1 - A",
      "section":"Ghost Snares",
      "PULSE":{
        "kick":null,
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "SN"
      ],
      "length":16,
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0.5
        ]
      },
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        1,
        0,
        0,
        0.5
      ]
    },
    "ghostsnare1B":{
      "name":"ghostsnare1B",
      "label":"GHOST SNARE 1 - B",
      "section":"Ghost Snares",
      "PULSE":{
        "kick":null,
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "SN"
      ],
      "length":16,
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "ghostsnare2A":{
      "name":"ghostsnare2A",
      "label":"GHOST SNARE 2 - A",
      "section":"Ghost Snares",
      "PULSE":{
        "kick":null,
        "snare":[
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "SN"
      ],
      "length":16,
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0.5
        ]
      },
      "snare":[
        0,
        0.5,
        0,
        0,
        1,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0.5
      ]
    },
    "ghostsnare2B":{
      "name":"ghostsnare2B",
      "label":"GHOST SNARE 2 - B",
      "section":"Ghost Snares",
      "PULSE":{
        "kick":null,
        "snare":[
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "SN"
      ],
      "length":16,
      "SN":{
        "snare":[
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0.5
        ]
      },
      "snare":[
        0,
        0.5,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        1,
        0,
        0,
        0.5
      ]
    },
    "contemporarykick1A":{
      "name":"contemporarykick1A",
      "label":"CONTEMPORARY KICK 1 - A",
      "section":"Breaks - Kick",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0
      ]
    },
    "contemporarykick1B":{
      "name":"contemporarykick1B",
      "label":"CONTEMPORARY KICK 1 - B",
      "section":"Breaks - Kick",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "contemporarykick2A":{
      "name":"contemporarykick2A",
      "label":"CONTEMPORARY KICK 2 - A",
      "section":"Breaks - Kick",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "contemporarykick2B":{
      "name":"contemporarykick2B",
      "label":"CONTEMPORARY KICK 2 - B",
      "section":"Breaks - Kick",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "contemporarykick3A":{
      "name":"contemporarykick3A",
      "label":"CONTEMPORARY KICK 3 - A",
      "section":"Breaks - Kick",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0
      ]
    },
    "contemporarykick3B":{
      "name":"contemporarykick3B",
      "label":"CONTEMPORARY KICK 3 - B",
      "section":"Breaks - Kick",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "contemporarykick4":{
      "name":"contemporarykick4",
      "label":"CONTEMPORARY KICK 4",
      "section":"Breaks - Kick",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "drumroll1":{
      "name":"drumroll1",
      "label":"DRUM ROLL 1",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":null,
        "snare":null
      },
      "HATS":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1
        ],
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          0,
          0
        ],
        "tom1":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "instruments":[
        "HT",
        "MT",
        "LT",
        "OH",
        "CY"
      ],
      "length":16,
      "HT":{
        "tom1":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          0,
          0
        ]
      },
      "LT":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1
        ]
      },
      "OH":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CY":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "tom1":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0
      ],
      "tom2":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0
      ],
      "tom3":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1
      ],
      "openHat":[
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "drumroll2":{
      "name":"drumroll2",
      "label":"DRUM ROLL 2",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0
        ],
        "snare":[
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN"
      ],
      "length":16,
      "BD":{
        "kick":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "kick":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0
      ],
      "snare":[
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0.5,
        0,
        0,
        0,
        0
      ]
    },
    "drumroll3":{
      "name":"drumroll3",
      "label":"DRUM ROLL 3",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":null,
        "snare":[
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0.5
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "SN"
      ],
      "length":16,
      "SN":{
        "snare":[
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0.5
        ]
      },
      "snare":[
        0.5,
        0.5,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0.5
      ]
    },
    "drumroll4":{
      "name":"drumroll4",
      "label":"DRUM ROLL 4",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "BD",
        "SN",
        "CY"
      ],
      "length":16,
      "BD":{
        "kick":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5
        ]
      },
      "CY":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "kick":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "snare":[
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5
      ],
      "openHat":[
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "drumroll5":{
      "name":"drumroll5",
      "label":"DRUM ROLL 5",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":null,
        "snare":null
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ],
        "tom2":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        "tom1":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "instruments":[
        "HT",
        "MT",
        "LT"
      ],
      "length":16,
      "HT":{
        "tom1":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "LT":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "tom1":[
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom2":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ],
      "tom3":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "drumroll6":{
      "name":"drumroll6",
      "label":"DRUM ROLL 6",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":null,
        "snare":null
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ],
        "tom2":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        "tom1":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "instruments":[
        "HT",
        "MT",
        "LT"
      ],
      "length":16,
      "HT":{
        "tom1":[
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "LT":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "tom1":[
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom2":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ],
      "tom3":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0
      ]
    },
    "drumroll7":{
      "name":"drumroll7",
      "label":"DRUM ROLL 7",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":null,
        "snare":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          0,
          1,
          0,
          0
        ],
        "tom2":[
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "tom1":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN"
      ],
      "length":16,
      "HT":{
        "tom1":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "LT":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          0,
          1,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "tom1":[
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom2":[
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom3":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        0,
        0
      ],
      "snare":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "drumroll8":{
      "name":"drumroll8",
      "label":"DRUM ROLL 8",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":null,
        "snare":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1
        ],
        "tom2":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        "tom1":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN"
      ],
      "length":16,
      "HT":{
        "tom1":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          1,
          0,
          0,
          0,
          0
        ]
      },
      "LT":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "tom1":[
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom2":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0
      ],
      "tom3":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1
      ],
      "snare":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "drumroll9":{
      "name":"drumroll9",
      "label":"DRUM ROLL 9",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":null,
        "snare":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ],
        "tom2":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        "tom1":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN"
      ],
      "length":16,
      "HT":{
        "tom1":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "LT":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "tom1":[
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom2":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ],
      "tom3":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0
      ],
      "snare":[
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "drumroll10":{
      "name":"drumroll10",
      "label":"DRUM ROLL 10",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":null,
        "snare":[
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1
        ],
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        "tom1":[
          0,
          0,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN"
      ],
      "length":16,
      "HT":{
        "tom1":[
          0,
          0,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          0,
          0,
          1,
          1,
          0,
          0,
          0,
          0
        ]
      },
      "LT":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0
        ]
      },
      "tom1":[
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom2":[
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0
      ],
      "tom3":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1
      ],
      "snare":[
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0
      ]
    },
    "drumroll11":{
      "name":"drumroll11",
      "label":"DRUM ROLL 11",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          1
        ],
        "tom2":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "tom1":[
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN",
        "BD"
      ],
      "length":16,
      "HT":{
        "tom1":[
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "LT":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          1
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0
        ]
      },
      "tom1":[
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0
      ],
      "tom2":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom3":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        1
      ],
      "snare":[
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0
      ]
    },
    "drumroll12":{
      "name":"drumroll12",
      "label":"DRUM ROLL 12",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "snare":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          1,
          0
        ],
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0
        ],
        "tom1":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN",
        "BD",
        "CY"
      ],
      "length":16,
      "HT":{
        "tom1":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "LT":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          1,
          0
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "CY":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "tom1":[
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom2":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0
      ],
      "tom3":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        0
      ],
      "snare":[
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "drumroll13":{
      "name":"drumroll13",
      "label":"DRUM ROLL 13",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5
        ],
        "snare":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ],
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "tom1":[
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN",
        "BD"
      ],
      "length":16,
      "HT":{
        "tom1":[
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "LT":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0.5
        ]
      },
      "tom1":[
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom2":[
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom3":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0
      ],
      "snare":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ],
      "kick":[
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0.5
      ]
    },
    "drumroll14":{
      "name":"drumroll14",
      "label":"DRUM ROLL 14",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":null,
        "snare":null
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":[
          1,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1
        ],
        "tom2":[
          0,
          0,
          0,
          1,
          1,
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          0,
          1,
          1,
          0
        ],
        "tom1":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          1,
          0,
          0,
          0
        ]
      },
      "instruments":[
        "HT",
        "MT",
        "LT"
      ],
      "length":16,
      "HT":{
        "tom1":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          1,
          0,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          1,
          1,
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          0,
          1,
          1,
          0
        ]
      },
      "LT":{
        "tom3":[
          1,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1
        ]
      },
      "tom1":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0
      ],
      "tom2":[
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        0
      ],
      "tom3":[
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1
      ]
    },
    "drumroll15":{
      "name":"drumroll15",
      "label":"DRUM ROLL 15",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":null,
        "snare":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":null,
        "hihat":null
      },
      "TOMS":{
        "tom3":[
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1
        ],
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "tom1":[
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN"
      ],
      "length":16,
      "HT":{
        "tom1":[
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "LT":{
        "tom3":[
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0
        ]
      },
      "tom1":[
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom2":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom3":[
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ],
      "snare":[
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0
      ]
    },
    "drumroll16":{
      "name":"drumroll16",
      "label":"DRUM ROLL 16",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "SN",
        "BD",
        "CH",
        "CY"
      ],
      "length":16,
      "SN":{
        "snare":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "CH":{
        "hihat":[
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "CY":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "snare":[
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0
      ],
      "kick":[
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0
      ],
      "hihat":[
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "drumroll17":{
      "name":"drumroll17",
      "label":"DRUM ROLL 17",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":null,
        "snare":[
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0.5
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "tom1":[
          0,
          0,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "instruments":[
        "HT",
        "MT",
        "SN",
        "CY"
      ],
      "length":16,
      "HT":{
        "tom1":[
          0,
          0,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0.5,
          0.5
        ]
      },
      "CY":{
        "openHat":[
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "tom1":[
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom2":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "snare":[
        0.5,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0.5,
        0.5
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "drumroll18":{
      "name":"drumroll18",
      "label":"DRUM ROLL 18",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "SN",
        "BD",
        "CY"
      ],
      "length":16,
      "SN":{
        "snare":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "CY":{
        "openHat":[
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0
        ]
      },
      "snare":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "kick":[
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0
      ],
      "openHat":[
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0
      ]
    },
    "drumroll19":{
      "name":"drumroll19",
      "label":"DRUM ROLL 19",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ],
        "snare":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":null,
        "tom2":null,
        "tom1":null
      },
      "instruments":[
        "SN",
        "BD",
        "CY"
      ],
      "length":16,
      "SN":{
        "snare":[
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0,
          0,
          0,
          0.5,
          0.5,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0,
          0.5,
          0
        ]
      },
      "CY":{
        "openHat":[
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "snare":[
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        0,
        0.5,
        0.5,
        0,
        0
      ],
      "kick":[
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0,
        0.5,
        0
      ],
      "openHat":[
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        1,
        0
      ]
    },
    "drumroll20":{
      "name":"drumroll20",
      "label":"DRUM ROLL 20",
      "section":"Drum Rolls",
      "PULSE":{
        "kick":[
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0
        ],
        "snare":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ]
      },
      "HATS":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "hihat":null
      },
      "TOMS":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1
        ],
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ],
        "tom1":[
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "instruments":[
        "HT",
        "MT",
        "LT",
        "SN",
        "BD",
        "CY"
      ],
      "length":16,
      "HT":{
        "tom1":[
          0,
          0,
          1,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "MT":{
        "tom2":[
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ]
      },
      "LT":{
        "tom3":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1
        ]
      },
      "SN":{
        "snare":[
          0.5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.5,
          0,
          0.5,
          0,
          0,
          0.5,
          0,
          0
        ]
      },
      "BD":{
        "kick":[
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0,
          0.5,
          0.5,
          0,
          0,
          0
        ]
      },
      "CY":{
        "openHat":[
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
      },
      "tom1":[
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "tom2":[
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ],
      "tom3":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1
      ],
      "snare":[
        0.5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0,
        0
      ],
      "kick":[
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0.5,
        0,
        0,
        0
      ],
      "openHat":[
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    }
  }
}